import React, { Component, Suspense } from 'react';
import './Frontpage.css';
// import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts';
import sendAnalytics from '../../Functions/analytics';
import paymentConfig from '../../Functions/paymentVariables';
// import largemap from '../../images/map_large.png';
// Deep import: the package root index requires every menu variant, which
// drags the 76 KiB snapsvg dependency (used only by elastic/bubble) into the
// main bundle. The slide menu itself never touches it.
import Menu from 'react-burger-menu/lib/menus/slide';
import { Helmet } from 'react-helmet';
// import selectedmap from '../../images/seleted_areas.PNG';
// import spread from '../../images/spread.jpg';
import spreadmid from '../../images/spreadmid.webp';
import houseicon from './icons/icons8-home-128.png';
// import news from './icons/icons8-news-120.png';
import aboutus from './icons/icons8-about-us-120.png';
import pricing from './icons/icons8-pricing-100.png';
import spreadsmall from '../../images/spreadsmall.webp';
import selectedAreas from '../../images/seleted_areas.webp';
import chartblue from './icons/chartblue.png';
import complete from './icons/icons8-complete-100.png';
import update from './icons/icons8-update-100.png';
import exclamation from './icons/icons8-exclamation-100.png';
import scatterPlot from '../../images/scatterPlot.png';
import success from './icons/icons8-success-48.png';
import buyer from './icons/icons8-buyer-96.png';
import sellers from './icons/icons8-property-96.png';
import sketch from './icons/icons8-sketchbook-64.png';
import buyerImage from './icons/undraw_build_your__home_csh6.svg';
import sellerImage from './icons/undraw_for_sale_re_egkk.svg';
import appraise from './icons/undraw_house_searching_re_stk8.svg';
import { trackCustom,track } from '../../Functions/pixel';
import {
    trackBeginCheckout,
    trackEvent,
    trackPageView,
    trackViewItemList
} from '../../Functions/ga4';
import {
    getSeoPageByPath,
    getCanonicalUrl,
    getAlternateUrls,
    getPrimaryLanguageName,
    getOfferCatalog
} from '../../seo/seoPages';

const publicPerformanceAsset = (path) => `${process.env.PUBLIC_URL || ''}/performance/${path}`;
const spreadsmallMobile480 = publicPerformanceAsset('spreadsmall-mobile-480.webp');
const spreadsmallMobile960 = publicPerformanceAsset('spreadsmall-mobile-960.webp');
const Logo = publicPerformanceAsset('casadata-logo-nav.webp');
const prmap = publicPerformanceAsset('prmap-small.webp');

const Chatbot = React.lazy(() => import('../Chat/Chatbot'));
// Interactive market statistics, embedded into the /es/estadisticas-* SEO
// routes. Lazy so the landing bundle stays light for everyone else.
const StatsEmbed = React.lazy(() => import('../Stats/Stats'));
const MunicipioStatsEmbed = React.lazy(() => import('../Stats/MunicipioStats'));
const LANDING_SCROLL_MILESTONES = [10, 25, 50, 75, 90];
const LANDING_SITE_ORIGIN = 'https://casadata.io';
const SEO_TOPIC_HANDOFF_DELAY_MS = 900;
const LANDING_VARIANT_BY_PATH = {
    '/realtor': 'realtors',
    '/realtors': 'realtors',
    '/tasadores': 'tasadores',
    '/inversionistas': 'inversionistas'
};
const LANDING_AUDIENCE_OVERRIDES = {
    realtors: {
        seo: {
            path: '/realtor',
            title: 'CASADATA para Corredores y Brokers en Puerto Rico | Comparables, captacion y cierre',
            description: 'Evalua comparables, Registro,  riesgo para captar listings, fijar precio y cerrar con menos sorpresas en Puerto Rico.',
            locale: 'es_PR',
            audienceLabel: 'Corredores y Brokers'
        },
        navTagline: 'Data y claridad para captar, listar y cerrar mejor',
        heroKicker: 'PARA CORREDORES Y BROKERS EN PUERTO RICO',
        heroTitle: (
            <>
                <span className='cdLpHeroTitleLine'>En Puerto Rico un listing no se gana solo con carisma.</span>
                <span className='cdLpHeroTitleLine'>Se gana con comparables, criterio y menos sorpresas.</span>
            </>
        ),
        heroSubtitle: 'CASADATA te ayuda a fijar precio con mas sustento y darle al cliente una explicacion mas clara desde la captacion hasta el cierre.',
        proofWorkflow: 'Captacion + pricing + ruta critica de cierre',
        proofUsedBy: 'Corredores, brokers, equipos de ventas y profesionales inmobiliarios',
        heroFinePrint: 'Menos improvisacion. Mas confianza frente al cliente. Mejor control del proceso.',
        overlayEyebrow: 'CLARIDAD PARA CAPTAR Y CERRAR',
        overlayTitle: 'Lo que un profesional inmobiliario necesita ver temprano para saber si una propiedad esta lista para listar, negociar y cerrar.',
        overlayCopy: 'Cuando precio, Registro y riesgo se leen antes, es mas facil inspirar confianza, evitar atrasos y defender cada recomendacion.',
        overlayChips: ['Captacion con mas certeza', 'Precio mejor sustentado', 'Cierre con menos retrasos'],
        trustCards: [
            {
                title: 'Captacion con mas confianza',
                value: 'Listings mejor preparados',
                description: 'Identifica temprano senales de Registro o riesgo que pueden complicar la salida al mercado.'
            },
            {
                title: 'Precio con mejor sustento',
                value: 'Comparables que aterrizan la conversacion',
                description: 'Defiende rango de listado y expectativa aun en mercados con inventario visible limitado.'
            },
            {
                title: 'Cierre mas controlado',
                value: 'Menos sorpresas en el proceso',
                description: 'Llega con mejor lectura para orientar al cliente, coordinar con terceros y mover la transaccion.'
            }
        ],
        howTitle: 'De captacion a cierre con menos friccion',
        howSubtitle: 'Pensado para el profesional que necesita listar con criterio, comunicar con claridad y anticipar problemas.',
        howSteps: [
            {
                title: 'Evalua si la propiedad esta lista para salir',
                description: 'Revisa zona, comparables y senales de preparacion antes de prometer precio o tiempo de cierre.'
            },
            {
                title: 'Sustenta precio y expectativa',
                description: 'Construye un CMA mas claro con contexto de inventario, ventas cerradas y condiciones que afectan la negociacion.'
            },
            {
                title: 'Comparte evidencia y mueve el proceso',
                description: 'Presenta visuales utiles para clientes, cooperadores, compradores remotos, notario o prestamista.'
            }
        ],
        roleTitle: 'Valor directo para la operacion del corredor en Puerto Rico',
        roleSubtitle: 'Util en captacion, buyer rep, listings complejos y cierres donde la confianza vale tanto como el precio.',
        roleCards: [
            {
                title: 'Captacion de listings con mas criterio',
                description: 'Llega a la cita con una lectura mas completa de precio, readiness y riesgo.'
            },
            {
                title: 'Claridad para clientes locales y diaspora',
                description: 'Resume mejor el panorama para duenos, compradores remotos y familiares que necesitan entender rapido.'
            },
            {
                title: 'Seguimiento mas serio del cierre',
                description: 'Ordena conversaciones sobre Registro, tasacion, seguro y proximo paso.'
            }
        ],
        demoTitle: 'Mira como un profesional inmobiliario puede pasar de una propiedad a una recomendacion mas lista para cliente y cierre',
        demoSubtitle: 'La demo ensena como convertir comparables, contexto y riesgo en una conversacion que transmite mas confianza.',
        evidenceTitle: 'Por que corredores y brokers disciplinados usan CASADATA',
        evidenceSubtitle: 'Porque en Puerto Rico vender bien exige mas que mercadeo: exige evidencia, claridad y menos improvisacion.',
        evidenceCards: [
            {
                title: 'Habla el idioma del proceso',
                description: 'Comparables, Registro de la Propiedad, tasacion y contexto de riesgo en una sola lectura.'
            },
            {
                title: 'Data mas reciente',
                description: 'Trabaja con información reciente para evitar sugerencias desfasadas frente al cliente.'
            },
            {
                title: 'Menos tiempo perdido',
                description: 'Reduce investigacion manual y enfoca tu energia en captar, explicar y cerrar.'
            }
        ],
        faqItems: [
            {
                question: 'Me ayuda a saber si una propiedad esta lista para listar?',
                answer: 'Si. Facilita una lectura inicial de precio, contexto, Registro y factores que pueden complicar la salida al mercado.'
            },
            {
                question: 'Sirve para listings y para buyer representation?',
                answer: 'Si. Te ayuda a sustentar precio, orientar expectativas y negociar con mas evidencia a ambos lados de la transaccion.'
            },
            {
                question: 'Puedo usarlo con clientes remotos o diaspora?',
                answer: 'Si. Las exportaciones y visuales ayudan a explicar mejor la propiedad a quien no esta presente en cada paso.'
            },
            {
                question: 'Ayuda a reducir atrasos en el cierre?',
                answer: 'Ayuda a detectar temprano senales que suelen atrasar cierre, para que cliente y terceros entren mejor preparados.'
            }
        ],
        finalTitle: 'En Puerto Rico el profesional que inspira mas confianza no es el que promete mas. Es el que llega con evidencia y anticipa mejor el camino al cierre.',
        finalPrimaryCta: 'Ver planes para corredores y brokers',
        finalSecondaryCta: 'Hablar con un especialista'
    },
    tasadores: {
        seo: {
            path: '/tasadores',
            title: 'CASADATA para Tasadores en Puerto Rico | Comparables y ventas cerradas',
            description: 'Compara ventas cerradas, delimita mercado y sustenta informes con datos trazables en Puerto Rico. Pensado para tasadores, peritos y analistas.',
            locale: 'es_PR',
            audienceLabel: 'Tasadores'
        },
        navTagline: 'Comparables para sustentar valor con claridad',
        heroKicker: 'COMPARABLES PARA TASADORES EN PUERTO RICO',
        heroTitle: 'Comparables de ventas cerradas para sustentar informes y conclusiones de valor con mayor precision en Puerto Rico.',
        heroSubtitle: 'Filtra por zona, tipo de propiedad, fecha y tamano; valida contexto con mapa y exporta evidencia para analisis, documentacion y defensa tecnica.',
        proofWorkflow: 'Filtros + mapa + exportacion CSV',
        proofUsedBy: 'Tasadores, peritos y analistas',
        heroFinePrint: 'Menos tiempo buscando comparables; mas tiempo interpretando valor con criterio profesional.',
        overlayEyebrow: 'SUSTENTO QUE RESISTE ESCRUTINIO',
        overlayTitle: 'La evidencia que un tasador necesita para justificar seleccion, rango y conclusion de valor.',
        overlayCopy: 'Cuando los comparables, la ubicacion y la exportacion estan alineados, el informe se defiende con mas claridad y menos friccion.',
        overlayChips: ['Seleccion comparable', 'Contexto geografico', 'Exportacion trazable'],
        trustCards: [
            {
                title: 'Cobertura para analisis',
                value: 'Puerto Rico completo',
                description: 'Consulta ventas cerradas por municipio con contexto geografico util para tu seleccion.'
            },
            {
                title: 'Comparables mas relevantes',
                value: 'Menos ruido en la busqueda',
                description: 'Ajusta filtros por fecha, precio y tamano para trabajar con evidencia mas util.'
            },
            {
                title: 'Menos friccion operativa',
                value: 'Mas tiempo para el criterio',
                description: 'Reduce recopilacion manual y concentra energia en analisis y documentacion.'
            }
        ],
        howTitle: 'De busqueda a informe en tres pasos',
        howSubtitle: 'Disenado para que pases de delimitar mercado a documentar evidencia con un flujo mas limpio.',
        howSteps: [
            {
                title: 'Delimita el mercado relevante',
                description: 'Selecciona area, tipo de propiedad y periodo para enfocar la muestra adecuada.'
            },
            {
                title: 'Selecciona y contrasta comparables',
                description: 'Valida transacciones recientes con contexto espacial y criterios consistentes.'
            },
            {
                title: 'Exporta y documenta',
                description: 'Lleva la evidencia a tu flujo de trabajo para sustentar informes y revisiones.'
            }
        ],
        roleTitle: 'Valor directo para tu proceso preciso',
        roleSubtitle: 'La plataforma te ayuda a seleccionar comparables, contextualizar y documentar con mayor velocidad.',
        roleCards: [
            {
                title: 'Seleccion comparable',
                description: 'Encuentra ventas cerradas que reduzcan ruido y refuercen la pertinencia de tu muestra.'
            },
            {
                title: 'Contexto de mercado',
                description: 'Usa mapa, periodo y filtros para leer mejor la zona y el comportamiento del mercado.'
            },
            {
                title: 'Soporte de informe',
                description: 'Exporta evidencia y conserva un flujo mas claro para revision, archivo y defensa tecnica.'
            }
        ],
        demoTitle: 'Mira como un tasador puede pasar de una zona a una evidencia mas facil de documentar',
        demoSubtitle: 'La demo resume como construir una base comparable con contexto util para informes y conclusiones de valor.',
        evidenceTitle: 'Por que tasadores y peritos confian en CASADATA',
        evidenceSubtitle: 'Información trazable, filtros claros y herramientas practicas para reducir friccion en tu analisis.',
        evidenceCards: [
            {
                title: 'Metodologia trazable',
                description: 'Cada busqueda deja visibles criterios y comparables utilizados.'
            },
            {
                title: 'Actualizacion continua',
                description: 'Trabaja con información reciente para reducir riesgo de usar evidencia desfasada.'
            },
            {
                title: 'Salida profesional',
                description: 'Lleva datos y exportaciones a tus documentos con menos trabajo manual.'
            }
        ],
        faqItems: [
            {
                question: 'Puedo filtrar por fecha, precio y tamano?',
                answer: 'Si. La plataforma permite acotar zona, rango de precio, periodo y tamano para enfocar mejor tus comparables.'
            },
            {
                question: 'Sirve para residencial y otros tipos de propiedad?',
                answer: 'Si. Puedes trabajar con diferentes tipologias segun la disponibilidad y el contexto del mercado.'
            },
            {
                question: 'Puedo exportar evidencia para mi flujo de trabajo?',
                answer: 'Si. CASADATA facilita exportaciones para documentacion, revision y analisis posterior.'
            },
            {
                question: 'Cubre toda Puerto Rico?',
                answer: 'Si. La cobertura es de toda la isla para apoyar trabajos en distintos municipios.'
            }
        ],
        finalTitle: 'Cuando la evidencia es clara y trazable, tu opinion de valor gana solidez.',
        finalPrimaryCta: 'Explorar planes para tasadores',
        finalSecondaryCta: 'Solicitar orientacion'
    },
    inversionistas: {
        seo: {
            path: '/inversionistas',
            title: 'CASADATA para Inversionistas en Puerto Rico | Comparables, diligencia y criterio de compra',
            description: 'Evalua comparables, CRIM, estatus registral, tasacion y salida potencial antes de comprometer capital en Puerto Rico.',
            locale: 'es_PR',
            audienceLabel: 'Inversionistas'
        },
        navTagline: 'Capital disciplinado para oportunidades en Puerto Rico',
        heroKicker: 'PARA INVERSIONISTAS QUE QUIEREN FILTRAR RUIDO Y PROTEGER CAPITAL',
        heroTitle: (
            <>
                <span className='cdLpHeroTitleLine'>Comprar Propiedad en Puerto Rico sin data es apostar.</span>
                <span className='cdLpHeroTitleLine'>Con Casadata, es estrategia.</span>
            </>
        ),
        heroSubtitle: 'Valida precio, friccion y salida potencial antes de entrar. Negocia con evidencia y protege tu capital de errores caros.',
        proofWorkflow: 'Comparables + diligencia + oferta sustentada',
        proofUsedBy: 'Inversionistas, equipos de adquisicion, brokers y socios',
        heroFinePrint: 'Menos intuicion. Mas disciplina de compra. Mejor posicion para entrar, negociar y salir.',
        overlayEyebrow: 'DILIGENCIA QUE REDUCE ERRORES CAROS',
        overlayTitle: 'Lo que un inversionista serio necesita ver temprano para distinguir una oportunidad real de una distraccion cara.',
        overlayCopy: 'Precio, comparables, CRIM, estatus registral y contexto de riesgo deben leerse antes de mover evidencia de fondos o firmar una oferta.',
        overlayChips: ['CASH ONLY con mas criterio', 'Entrada mejor sustentada', 'Salida mas defendible'],
        trustCards: [
            {
                title: 'Friccion identificada temprano',
                value: 'Menos capital atrapado',
                description: 'Detecta senales de tasacion, Registro o riesgo territorial que pueden romper rendimiento, financiamiento o salida.'
            },
            {
                title: 'Precio mas defendible',
                value: 'Menos hype, mas criterio',
                description: 'Contrasta rango, liquidez y potencial de renta con ventas cerradas y micro-mercados reales.'
            },
            {
                title: 'Negociacion con ventaja',
                value: 'Mejor posicion para ofertar',
                description: 'Llega con evidencia para hablar con corredor, vendedor, socio, comite o prestamista sin improvisar.'
            }
        ],
        howTitle: 'De lead atractivo a compra disciplinada',
        howSubtitle: 'Pensado para el inversionista que quiere filtrar rapido, profundizar con criterio y mover capital solo cuando la tesis aguanta.',
        howSteps: [
            {
                title: 'Filtra lo que merece tu tiempo',
                description: 'Define mercado, activo y rango para descartar rapido lo que no cumple tu buy box.'
            },
            {
                title: 'Valida valor y friccion real',
                description: 'Contrasta AS IS, CASH ONLY, renta potencial y contexto de riesgo frente a ventas cerradas y lectura local.'
            },
            {
                title: 'Oferta con base, no con impulso',
                description: 'Exporta evidencia y entra a la conversacion con mejor sustento para negociar termino, precio y velocidad de cierre.'
            }
        ],
        roleTitle: 'Valor directo para comprar con mas criterio en Puerto Rico',
        roleSubtitle: 'Util para buy and hold, multifamiliar, value-add y oportunidades donde la entrada importa tanto como la salida.',
        roleCards: [
            {
                title: 'Filtro inicial con mas disciplina',
                description: 'Sabes temprano si precio, zona y friccion justifican visitas, diligencia y evidencia de fondos.'
            },
            {
                title: 'Lectura mas seria del mercado',
                description: 'Aterriza comparables, tendencia y potencial con contexto local, no con entusiasmo prestado.'
            },
            {
                title: 'Soporte listo para socios y credito',
                description: 'Lleva evidencia clara a conversaciones con socios, comites, corredores o prestamistas.'
            }
        ],
        demoTitle: 'Mira como un inversionista puede separar rapido una oportunidad real de una distraccion cara',
        demoSubtitle: 'La demo ensena como usar comparables, contexto y exportaciones para filtrar, validar y negociar con mas disciplina.',
        evidenceTitle: 'Por que los inversionistas mas disciplinados se apoyan en CASADATA',
        evidenceSubtitle: 'Porque en Puerto Rico comprar bien exige data dificil de reunir, contexto local y una lectura mas sobria antes de comprometer capital.',
        evidenceCards: [
            {
                title: 'Habla el idioma del underwriting',
                description: 'Comparables, CRIM, Registro, tendencia y contexto territorial en una sola lectura.'
            },
            {
                title: 'Actualizacion que acorta reaccion',
                description: 'Trabaja con data reciente para no llegar tarde ni pagar de mas por una narrativa bonita.'
            },
            {
                title: 'Material listo para comites y socios',
                description: 'Exporta evidencia para ofertas, financiamiento, analisis interno y conversaciones de diligencia.'
            }
        ],
        faqItems: [
            {
                question: 'Me ayuda a saber si un CASH ONLY / AS IS justifica seguir adelante?',
                answer: 'Si. Permite contrastar precio y contexto antes de invertir mas tiempo en visitas, evidencia de fondos y diligencia.'
            },
            {
                question: 'Sirve para buy & hold, multifamiliar, flip o rentas a largo plazo?',
                answer: 'Si. Apoya estrategias donde cash flow, valor de reventa y potencial de salida deben quedar mejor sustentados.'
            },
            {
                question: 'Puedo usarlo para negociar mejor con corredores, vendedores o prestamistas?',
                answer: 'Si. Llegas con comparables, rango y preguntas mas precisas.'
            },
            {
                question: 'Me ayuda a decidir si una propiedad merece visita, evidencia de fondos o distancia?',
                answer: 'Si. Te ayuda a filtrar temprano que vale seguimiento y que probablemente solo te consumira tiempo y enfoque.'
            }
        ],
        finalTitle: 'En Puerto Rico las mejores compras no siempre son las que mas llaman la atencion. Son las que resisten la diligencia antes de pedirte capital.',
        finalPrimaryCta: 'Ver planes para inversionistas',
        finalSecondaryCta: 'Hablar con un especialista'
    }
};


class Frontpage extends Component{
    constructor(props){
        super(props);
        this.state={
            showFirstContent:true,
            showSecondContent:false,
            windowTooSmallAdjustClass:'',
            lowerAdjustClass:'',
            infoWindowIndex:'terms',
            textIndex:'default',
            videoDarkenClass:'videoDarken',
            indexedSavings:'',
            isIos:/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
            plusMaxPrice:[paymentConfig.plusMaxMonthly,' Mensual (Monthly)','monthly'],
            plusMaxBilling: 'monthly', // 'monthly' | 'annual'
            proBilling: 'monthly', // PlusMAX Pro card: 'monthly' | 'annual'
            defaultRadio:true,
            privateSelectorClass:'motivationalSelected',
            realtorSelectorClass:'motivationalSelector',
            appraiserSelectorClass:'motivationalSelector',
            scatterStyle:'scatterStyle',
            scatterContainer:'scatterContainer',
            secondContentContainer:'secondContentContainer',
            lowerButtonClass1:'showcaseButton showcaseButtonActive',
            lowerButtonClass2:'showcaseButton',
            lowerButtonClass3:'showcaseButton',
            customerIndex:'buyer',
            scrollPosition:0,
            scrollThreshhold1:500,
            scrollThreshhold2:1200,
            isVisible1:true,
            isVisible2:true,
            contentIndex: (this.props.landingTarget === 'prices' ? 'prices' : 'main'),
            seoTopicHold: true,
            menuOpen: false,
            contactName:'',
            contactEmail:'',
            contactPhone:'',
            contactMessage:'',
            contactSent: false,
            serverIp:this.props.serverIp,
            seatInfo: null,
            seatLoading: false,
            seatError: '',
            trialOfferVisibility: 'loading',
            trialEligibilityReason: '',
            trialEligibilityRid: '',
            trialEligibilityFingerprint: '',
            enableChatbot: false,
            showDemoVideo: false,
            heroFreshness: this.getStoredHeroFreshness()
        };
        this.handleResizeWindow = () => this.adjustWindowSize();
        this.handleResizeScatter = () => this.scatterStyleIndexer();
        this.chatbotTimer = null;
        this.chatbotIdleHandle = null;
        this.heroFreshnessTimer = null;
        this.heroFreshnessIdleHandle = null;
        this.seoTopicSwitchTimer = null;
        this.trialEligibilityPending = false;
        this.trialEligibilityBridgeCleanup = null;
        this.customerFingerprintPromise = null;
        this.isFrontpageUnmounted = false;

        // Landing analytics session state (deduped funnel signals)
        this.landingSessionId = `fp_${Date.now()}_${Math.random().toString(16).slice(2, 8)}`;
        this.landingSessionStartTs = 0;
        this.landingMaxScroll = 0;
        this.landingLastSection = 'none';
        this.landingScrollMilestonesSeen = new Set();
        this.landingSectionSeen = new Set();
        this.landingObserver = null;
        this.landingListenersAttached = false;
        this.landingExitSent = false;
        this.handleLandingScroll = () => this.captureLandingScroll();
        this.handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                this.captureLandingExit('visibility_hidden');
            }
        };
        this.handleBeforeUnload = () => this.captureLandingExit('before_unload');
    }

    getMotionStyle(index = 0) {
        return { '--motion-index': index };
    }

    ensureHeroPreloadLink() {
        const linkId = 'cd-lcp-preload';
        if (typeof document === 'undefined') return;
        if (this.getSeoTopicPage()) return;
        if (document.getElementById(linkId)) return;

        const isMobileHero = typeof window !== 'undefined' && window.innerWidth < 1264;
        const preload = document.createElement('link');
        preload.id = linkId;
        preload.rel = 'preload';
        preload.as = 'image';
        preload.href = isMobileHero ? spreadsmallMobile960 : spreadsmall;
        preload.setAttribute('fetchpriority', 'high');
        if (isMobileHero) {
            preload.setAttribute('media', '(max-width: 1263px)');
            preload.setAttribute('imagesrcset', `${spreadsmallMobile480} 480w, ${spreadsmallMobile960} 960w`);
            preload.setAttribute('imagesizes', '100vw');
        } else {
            preload.setAttribute('imagesrcset', `${spreadsmall} 1532w, ${spreadmid} 2486w`);
            preload.setAttribute('imagesizes', '58vw');
        }
        document.head.appendChild(preload);
    }

    getStoredHeroFreshness() {
        if (typeof window === 'undefined') {
            return { label_es: '', label_en: '', date_iso: '', source: '' };
        }
        try {
            const raw = window.localStorage.getItem('casadata_hero_freshness');
            if (!raw) {
                return { label_es: '', label_en: '', date_iso: '', source: '' };
            }
            const parsed = JSON.parse(raw);
            return {
                label_es: String(parsed?.label_es || ''),
                label_en: String(parsed?.label_en || ''),
                date_iso: String(parsed?.date_iso || ''),
                source: String(parsed?.source || '')
            };
        } catch {
            return { label_es: '', label_en: '', date_iso: '', source: '' };
        }
    }

    persistHeroFreshness(freshness) {
        if (typeof window === 'undefined') return;
        try {
            window.localStorage.setItem('casadata_hero_freshness', JSON.stringify(freshness));
        } catch {}
    }

    formatMonthYearFromUnix(unixSeconds, language = 'spanish') {
        const unix = Number(unixSeconds);
        if (!Number.isFinite(unix) || unix <= 0) {
            return '';
        }
        const locale = language === 'english' ? 'en-US' : 'es-PR';
        const formattedDate = new Intl.DateTimeFormat(locale, {
            month: 'long',
            year: 'numeric',
            timeZone: 'America/Puerto_Rico'
        }).format(new Date(unix * 1000));

        return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    }

    getCurrentMonthYearLabel(language = 'spanish') {
        return this.formatMonthYearFromUnix(Math.floor(Date.now() / 1000), language);
    }

    setHeroFreshnessState(freshness) {
        this.setState({ heroFreshness: freshness });
        this.persistHeroFreshness(freshness);
    }

    fetchHeroFreshnessFallback() {
        if (!this.state.serverIp) return;

        fetch(`${this.state.serverIp}/api/plusmaxSeatStatus`, { method: 'GET' })
            .then((response) => response.json())
            .then((data) => {
                const freshness = {
                    label_es: this.formatMonthYearFromUnix(data?.as_of_unix, 'spanish'),
                    label_en: this.formatMonthYearFromUnix(data?.as_of_unix, 'english'),
                    date_iso: '',
                    source: 'plusmaxSeatStatus_as_of_unix'
                };
                if (freshness.label_es || freshness.label_en) {
                    this.setHeroFreshnessState(freshness);
                }
            })
            .catch(() => {});
    }

    fetchHeroFreshness() {
        if (!this.state.serverIp) return;

        fetch(`${this.state.serverIp}/api/landingDataFreshness`, { method: 'GET' })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`landingDataFreshness_${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                const freshness = {
                    label_es: String(data?.label_es || ''),
                    label_en: String(data?.label_en || ''),
                    date_iso: String(data?.date_iso || ''),
                    source: String(data?.source || '')
                };
                if (!freshness.label_es && !freshness.label_en) {
                    throw new Error('landingDataFreshness_missing_labels');
                }
                this.setHeroFreshnessState(freshness);
            })
            .catch(() => {
                this.fetchHeroFreshnessFallback();
            });
    }

    cleanAnalyticsValue(value, max = 24) {
        return String(value ?? '')
            .replace(/[|,]/g, '_')
            .replace(/\s+/g, '_')
            .replace(/[^a-zA-Z0-9_:-]/g, '')
            .slice(0, max) || 'na';
    }

    getViewportBucket() {
        if (typeof window === 'undefined') return 'na';
        if (window.innerWidth < 700) return 'm';
        if (window.innerWidth < 1100) return 't';
        return 'd';
    }

    getLanguageBucket() {
        return this.props.selectedLanguage === 'english' ? 'en' : 'es';
    }

    getCurrentPathname() {
        if (typeof window === 'undefined') return '/';
        return String(window.location.pathname || '/');
    }

    getSeoTopicPage() {
        const page = getSeoPageByPath(this.getCurrentPathname());
        return page && page.kind === 'topic' ? page : null;
    }

    getSeoSchemaJson(page) {
        const faqEntities = (page.faqs || []).map((item) => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer
            }
        }));

        const graph = [
            {
                '@context': 'https://schema.org',
                '@type': 'Organization',
                name: 'CASADATA',
                url: 'https://casadata.io/',
                logo: 'https://casadata.io/android-chrome-512x512.png',
                contactPoint: [
                    {
                        '@type': 'ContactPoint',
                        contactType: 'customer support',
                        email: 'information@casadata.io',
                        availableLanguage: ['Spanish', 'English']
                    }
                ]
            },
            {
                '@context': 'https://schema.org',
                '@type': 'WebPage',
                name: page.title,
                description: page.description,
                url: getCanonicalUrl(page),
                inLanguage: page.language,
                about: page.eyebrow || 'Puerto Rico real estate data',
                publisher: {
                    '@type': 'Organization',
                    name: 'CASADATA',
                    url: 'https://casadata.io/'
                }
            },
            {
                '@context': 'https://schema.org',
                '@type': 'SoftwareApplication',
                name: 'CASADATA',
                applicationCategory: 'BusinessApplication',
                operatingSystem: 'Web',
                url: 'https://casadata.io/',
                description: 'Puerto Rico real estate comparables and sales analytics platform.',
                areaServed: {
                    '@type': 'AdministrativeArea',
                    name: 'Puerto Rico'
                },
                offers: getOfferCatalog()
            }
        ];

        if (page.includeOfferCatalog) {
            graph.push({
                '@context': 'https://schema.org',
                ...getOfferCatalog()
            });
        }

        if (faqEntities.length > 0) {
            graph.push({
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: faqEntities
            });
        }

        return JSON.stringify(graph).replace(/</g, '\\u003c');
    }

    renderSeoTopicHelmet(page) {
        const canonicalUrl = getCanonicalUrl(page);
        const imageUrl = 'https://casadata.io/android-chrome-512x512.png';
        const htmlLang = page.language === 'en-US' ? 'en' : 'es';
        const locale = page.language === 'en-US' ? 'en_US' : 'es_PR';

        return (
            <Helmet>
                <html lang={htmlLang} />
                <title>{page.title}</title>
                <meta name='description' content={page.description} />
                <meta name='robots' content='index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1' />
                <link rel='canonical' href={canonicalUrl} />
                {getAlternateUrls(page).map((entry) => (
                    <link key={entry.hreflang} rel='alternate' hrefLang={entry.hreflang.toLowerCase()} href={entry.href} />
                ))}
                <meta property='og:type' content='website' />
                <meta property='og:site_name' content='CASADATA' />
                <meta property='og:url' content={canonicalUrl} />
                <meta property='og:title' content={page.title} />
                <meta property='og:description' content={page.description} />
                <meta property='og:image' content={imageUrl} />
                <meta property='og:locale' content={locale} />
                {page.alternates && page.alternates['en-US'] && page.language !== 'en-US' ? (
                    <meta property='og:locale:alternate' content='en_US' />
                ) : null}
                {page.alternates && page.alternates['es-PR'] && page.language !== 'es-PR' ? (
                    <meta property='og:locale:alternate' content='es_PR' />
                ) : null}
                <meta name='twitter:card' content='summary_large_image' />
                <meta name='twitter:title' content={page.title} />
                <meta name='twitter:description' content={page.description} />
                <meta name='twitter:image' content={imageUrl} />
                <script
                    type='application/ld+json'
                    dangerouslySetInnerHTML={{ __html: this.getSeoSchemaJson(page) }}
                />
            </Helmet>
        );
    }

    renderSeoTopicPage(page) {
        const languageLinks = getAlternateUrls(page)
            .filter((entry) => entry.hreflang !== 'x-default')
            .map((entry) => {
                let pathname = '/';
                try {
                    pathname = new URL(entry.href).pathname;
                } catch {
                    pathname = entry.href;
                }
                return { ...entry, pathname };
            });

        return (
            <main className='cdSeoRoute' id='mainContainer'>
                {this.renderSeoTopicHelmet(page)}
                <section className='cdSeoHero'>
                    <div className='cdSeoEyebrow'>{page.eyebrow}</div>
                    <h1>{page.h1}</h1>
                    {(page.intro || []).map((paragraph, index) => (
                        <p key={`intro-${index}`}>{paragraph}</p>
                    ))}
                    <div className='cdSeoActions'>
                        <button
                            type='button'
                            className='cdSeoPrimaryBtn'
                            onClick={() => this.routeToPricing(`seo_${page.slug || 'topic'}_primary`)}
                        >
                            {page.primaryCta || this.languageIndexer('Ver planes', 'View plans')}
                        </button>
                        <button
                            type='button'
                            className='cdSeoSecondaryBtn'
                            onClick={() => this.routeToContact(`seo_${page.slug || 'topic'}_secondary`)}
                        >
                            {page.secondaryCta || this.languageIndexer('Contactar', 'Contact')}
                        </button>
                    </div>
                    <div className='cdSeoLanguageLinks' aria-label='Language alternatives'>
                        {languageLinks.map((entry) => (
                            <a key={entry.hreflang} href={entry.pathname}>
                                {entry.hreflang.toUpperCase()}
                            </a>
                        ))}
                    </div>
                </section>

                <section className='cdSeoQuickProof'>
                    <div>
                        <strong>{page.language === 'en-US' ? 'Market focus' : 'Enfoque local'}</strong>
                        <span>Puerto Rico</span>
                    </div>
                    <div>
                        <strong>{page.language === 'en-US' ? 'Data workflow' : 'Flujo de datos'}</strong>
                        <span>{page.language === 'en-US' ? 'Closed sales + map filters' : 'Ventas cerradas + filtros de mapa'}</span>
                    </div>
                    <div>
                        <strong>{page.language === 'en-US' ? 'Language' : 'Idioma'}</strong>
                        <span>{getPrimaryLanguageName(page)}</span>
                    </div>
                </section>

                {page.statsEmbed ? (
                    <section className='cdSeoStatsEmbed'>
                        <Suspense
                            fallback={
                                <div className='statsLoadingCard'>
                                    {page.language === 'en-US' ? 'Loading statistics…' : 'Cargando estadísticas…'}
                                </div>
                            }
                        >
                            {page.statsEmbed.scope === 'municipio' ? (
                                <MunicipioStatsEmbed
                                    slug={page.statsEmbed.slug}
                                    variant='embedded'
                                    selectedLanguage={page.language === 'en-US' ? 'english' : 'spanish'}
                                />
                            ) : (
                                <StatsEmbed
                                    variant='embedded'
                                    selectedLanguage={page.language === 'en-US' ? 'english' : 'spanish'}
                                />
                            )}
                        </Suspense>
                    </section>
                ) : null}

                {(page.sections || []).map((section, index) => (
                    <section className='cdSeoSection' key={`seo-section-${index}`}>
                        <h2>{section.heading}</h2>
                        {(section.body || []).map((paragraph, paragraphIndex) => (
                            <p key={`seo-section-${index}-${paragraphIndex}`}>{paragraph}</p>
                        ))}
                        {(section.items || []).length > 0 ? (
                            <ul className='cdSeoList'>
                                {section.items.map((item, itemIndex) => (
                                    <li key={`seo-section-${index}-item-${itemIndex}`}>{item}</li>
                                ))}
                            </ul>
                        ) : null}
                        {(section.articles || []).length > 0 ? (
                            <div className='cdSeoArticles'>
                                {section.articles.map((article, articleIndex) => (
                                    <article key={`seo-section-${index}-article-${articleIndex}`}>
                                        <h3>{article.heading}</h3>
                                        {(article.body || []).map((paragraph, paragraphIndex) => (
                                            <p key={`seo-section-${index}-article-${articleIndex}-${paragraphIndex}`}>{paragraph}</p>
                                        ))}
                                        {(article.items || []).length > 0 ? (
                                            <ul className='cdSeoList'>
                                                {article.items.map((item, itemIndex) => (
                                                    <li key={`seo-section-${index}-article-${articleIndex}-item-${itemIndex}`}>{item}</li>
                                                ))}
                                            </ul>
                                        ) : null}
                                    </article>
                                ))}
                            </div>
                        ) : null}
                        {section.table && (section.table.headers || []).length > 0 ? (
                            <div className='cdSeoTableWrap'>
                                <table>
                                    <thead>
                                        <tr>
                                            {section.table.headers.map((header, headerIndex) => (
                                                <th key={`seo-section-${index}-table-header-${headerIndex}`}>{header}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(section.table.rows || []).map((row, rowIndex) => (
                                            <tr key={`seo-section-${index}-table-row-${rowIndex}`}>
                                                {row.map((cell, cellIndex) => (
                                                    <td key={`seo-section-${index}-table-row-${rowIndex}-cell-${cellIndex}`}>{cell}</td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : null}
                        {(section.links || []).length > 0 ? (
                            <div className='cdSeoLinks'>
                                {section.links.map((link, linkIndex) => (
                                    <a key={`seo-section-${index}-link-${linkIndex}`} href={link.href}>{link.label}</a>
                                ))}
                            </div>
                        ) : null}
                    </section>
                ))}

                {(page.faqs || []).length > 0 ? (
                    <section className='cdSeoFaq'>
                        <h2>{page.language === 'en-US' ? 'Frequently asked questions' : 'Preguntas frecuentes'}</h2>
                        {(page.faqs || []).map((item, index) => (
                            <article className='cdSeoFaqItem' key={`seo-faq-${index}`}>
                                <h3>{item.question}</h3>
                                <p>{item.answer}</p>
                            </article>
                        ))}
                    </section>
                ) : null}

                <section className='cdSeoFinalCta'>
                    <h2>{page.language === 'en-US' ? 'Turn Puerto Rico real estate data into a clearer decision.' : 'Convierte datos inmobiliarios de Puerto Rico en una decision mas clara.'}</h2>
                    <button
                        type='button'
                        className='cdSeoPrimaryBtn'
                        onClick={() => this.routeToPricing(`seo_${page.slug || 'topic'}_final`)}
                    >
                        {page.primaryCta || this.languageIndexer('Ver planes', 'View plans')}
                    </button>
                </section>
            </main>
        );
    }

    getLandingVariantKey() {
        if (typeof window === 'undefined') return 'default';

        const normalizedPath = String(window.location.pathname || '/')
            .toLowerCase()
            .replace(/\/+$/, '') || '/';

        return LANDING_VARIANT_BY_PATH[normalizedPath] || 'default';
    }

    getLandingCopy() {
        const heroFreshnessLabel = this.getHeroFreshnessLabel();
        const selectedLanguage = this.props.selectedLanguage === 'english' ? 'english' : 'spanish';
        const variantKey = this.getLandingVariantKey();
        const overrides = LANDING_AUDIENCE_OVERRIDES[variantKey] || {};
        const baseSeoTitle = this.languageIndexer(
            'CASADATA | Comparables y ventas cerradas en Puerto Rico',
            'CASADATA | Puerto Rico Real Estate Comparables and Sales Data'
        );
        const baseSeoDescription = this.languageIndexer(
            'Comparables de ventas cerradas, mapas interactivos y exportaciones para sustentar valor, compra, venta e inversion en Puerto Rico.',
            'Analyze Puerto Rico property comparables, sales history, and market trends with CASADATA.'
        );
        const defaultCopy = {
            variantKey,
            seo: {
                path: '/',
                title: baseSeoTitle,
                description: baseSeoDescription,
                locale: selectedLanguage === 'english' ? 'en_US' : 'es_PR',
                audienceLabel: 'CASADATA'
            },
            navTagline: this.languageIndexer(
                'Confia en los datos, confia en tu inversion',
                'Trust data to guide your investment'
            ),
            heroKicker: this.languageIndexer(
                'VENTAS HISTORICAS Y COMPARABLES DE PUERTO RICO',
                'PUERTO RICO CLOSED-SALE COMPS'
            ),
            heroTitle: this.languageIndexer(
                'Comparables de ventas cerradas en Puerto Rico para determinar precio, sustentar valor, comprar y vender con confianza.',
                'Puerto Rico closed-sale comps to price, support valuations, and buy with confidence.'
            ),
            heroSubtitle: this.languageIndexer(
                'Accede a historial completo de ventas verificadas, mapas interactivos y exportaciones listas para sustentar valor con precision en cualquier municipio.',
                'Access complete verified sale history, interactive maps, and exports ready to defend value with precision in any municipality.'
            ),
            heroFreshnessLabel,
            proofCoverage: this.languageIndexer('Puerto Rico completo', 'Full Puerto Rico footprint'),
            proofWorkflow: this.languageIndexer('Mapa interactivo + exportacion CSV', 'Interactive map + CSV export'),
            proofUsedBy: this.languageIndexer('Compradores, Corredores y Tasadores', 'Buyers, sellers, and appraisers'),
            heroPrimaryCta: this.languageIndexer('Ver precios', 'View pricing'),
            heroSecondaryCta: this.languageIndexer('Ver demo de 2 minutos', 'Watch a 2-minute demo'),
            heroFinePrint: this.languageIndexer(
                'Datos reales para defender precio con rapidez, claridad y confianza local.',
                'Real sale data to defend price with speed, clarity, and local confidence.'
            ),
            overlayEyebrow: this.languageIndexer('PRUEBA QUE REDUCE DUDAS', 'PROOF THAT LOWERS HESITATION'),
            overlayTitle: this.languageIndexer(
                'La evidencia que necesitan tasadores, corredores y compradores para confiar en el precio.',
                'The evidence appraisers, agents, and buyers need to trust the price.'
            ),
            overlayCopy: this.languageIndexer(
                'Cuando la venta cerrada, el mapa y la exportacion estan listos, la conversacion pasa de opinion a sustento.',
                'When the closed sale, map view, and export are ready, the conversation moves from opinion to evidence.'
            ),
            overlayChips: [
                this.languageIndexer('Ventas cerradas verificadas', 'Verified closed sales'),
                this.languageIndexer('Cobertura isla completa', 'Island-wide coverage'),
                this.languageIndexer('Listo para presentar', 'Ready to present')
            ],
            trustCards: [
                {
                    title: this.languageIndexer('Cobertura estrategica', 'Strategic coverage'),
                    value: this.languageIndexer('Puerto Rico completo', 'Full Puerto Rico coverage'),
                    description: this.languageIndexer(
                        'Visualiza ventas por municipio con contexto para defender cada recomendacion.',
                        'Review sales by municipality with context you can confidently present.'
                    )
                },
                {
                    title: this.languageIndexer('Comparables que convencen', 'Convincing comparables'),
                    value: this.languageIndexer('Datos listos para presentar', 'Presentation-ready data'),
                    description: this.languageIndexer(
                        'Aterriza precio, tiempo y tendencia en un flujo claro para clientes exigentes.',
                        'Turn pricing, timing, and trend data into clear recommendations for demanding clients.'
                    )
                },
                {
                    title: this.languageIndexer('Eficiencia operativa', 'Operational efficiency'),
                    value: this.languageIndexer('Menos horas, mas cierres', 'Less manual work, more closes'),
                    description: this.languageIndexer(
                        'Reduce investigacion manual y enfocate en negociar y capturar oportunidades.',
                        'Reduce manual research and spend more time negotiating and capturing opportunities.'
                    )
                }
            ],
            howTitle: this.languageIndexer('De pregunta a decision en tres pasos', 'From question to decision in three steps'),
            howSubtitle: this.languageIndexer(
                'Disenado para pasar de buscar datos a justificar valor sin friccion.',
                'Designed to move from raw data to clear value justification with minimal friction.'
            ),
            howSteps: [
                {
                    title: this.languageIndexer('Enfoca el mercado', 'Focus the market'),
                    description: this.languageIndexer(
                        'Selecciona zona, tipo de propiedad y periodo para eliminar ruido.',
                        'Select area, property type, and time period to remove noise.'
                    )
                },
                {
                    title: this.languageIndexer('Construye evidencia', 'Build evidence'),
                    description: this.languageIndexer(
                        'Compara transacciones recientes y valida rangos de precio con contexto real.',
                        'Compare recent transactions and validate price ranges with real context.'
                    )
                },
                {
                    title: this.languageIndexer('Presenta y actua', 'Present and act'),
                    description: this.languageIndexer(
                        'Exporta analisis listos para cerrar conversaciones con claridad.',
                        'Export analysis ready to move conversations to clear decisions.'
                    )
                }
            ],
            roleTitle: this.languageIndexer('Valor directo para cada perfil', 'Direct value for each profile'),
            roleSubtitle: this.languageIndexer(
                'Misma plataforma, beneficios concretos segun tu objetivo.',
                'Same platform, concrete outcomes based on your objective.'
            ),
            roleCards: [
                {
                    title: this.languageIndexer('Compradores', 'Buyers'),
                    description: this.languageIndexer(
                        'Detecta propiedades con mejor potencial antes de ofertar.',
                        'Identify higher-potential opportunities before submitting offers.'
                    )
                },
                {
                    title: this.languageIndexer('Vendedores', 'Sellers'),
                    description: this.languageIndexer(
                        'Define estrategia de precio para vender con margen y menor incertidumbre.',
                        'Set pricing strategy to sell with stronger margin and lower uncertainty.'
                    )
                },
                {
                    title: this.languageIndexer('Tasadores', 'Appraisers'),
                    description: this.languageIndexer(
                        'Sustenta informes con comparables relevantes y criterios transparentes.',
                        'Support reports with relevant comparables and transparent criteria.'
                    )
                }
            ],
            demoTitle: this.languageIndexer('Mira como se traduce en resultados', 'See how this turns into results'),
            demoSubtitle: this.languageIndexer(
                'Esta demo muestra como pasar de una zona a un reporte util para decisiones reales.',
                'This demo shows how to go from an area search to a report that supports real decisions.'
            ),
            demoPrimaryCta: this.languageIndexer('Ver planes y acceso', 'View plans and access'),
            demoSecondaryCta: this.languageIndexer('Hablar con un especialista', 'Talk to a specialist'),
            playDemoLabel: this.languageIndexer('Reproducir demo', 'Play demo'),
            evidenceTitle: this.languageIndexer('Por que profesionales confian en CASADATA', 'Why professionals trust CASADATA'),
            evidenceSubtitle: this.languageIndexer(
                'Información trazable, metodologia clara y herramientas pensadas para tomar accion.',
                'Traceable data, clear methodology, and tools designed for action.'
            ),
            evidenceCards: [
                {
                    title: this.languageIndexer('Metodologia transparente', 'Transparent methodology'),
                    description: this.languageIndexer(
                        'Cada busqueda muestra criterios y comparables utilizados.',
                        'Each search clearly shows the criteria and comparables used.'
                    )
                },
                {
                    title: this.languageIndexer('Actualizacion continua', 'Continuous updates'),
                    description: this.languageIndexer(
                        'Trabaja con información reciente para reducir decisiones desfasadas.',
                        'Work with recent data to reduce outdated decisions.'
                    )
                },
                {
                    title: this.languageIndexer('Salida profesional', 'Professional output'),
                    description: this.languageIndexer(
                        'Entrega reportes entendibles para clientes y comites de inversion.',
                        'Deliver reports your clients and investment committees can easily understand.'
                    )
                }
            ],
            faqTitle: this.languageIndexer('Preguntas frecuentes', 'Frequently asked questions'),
            faqItems: [
                {
                    question: this.languageIndexer('Que incluye el plan PlusMAX?', 'What does the PlusMAX plan include?'),
                    answer: this.languageIndexer(
                        'Incluye comparables, filtros avanzados, herramientas estadisticas y exportacion de datos.',
                        'It includes comparables, advanced filters, statistical tools, and data exports.'
                    )
                },
                {
                    question: this.languageIndexer('Puedo cancelar la suscripcion?', 'Can I cancel my subscription?'),
                    answer: this.languageIndexer(
                        'Si. La facturacion es recurrente y puedes cancelar cuando quieras.',
                        'Yes. Billing is recurring and you can cancel anytime.'
                    )
                },
                {
                    question: this.languageIndexer('Ofrecen soporte?', 'Do you provide support?'),
                    answer: this.languageIndexer(
                        'Si. Nuestro equipo responde solicitudes en un plazo estimado de 24 horas laborables.',
                        'Yes. Our team replies within an estimated 24 business hours.'
                    )
                },
                {
                    question: this.languageIndexer('Puedo hablar antes de suscribirme?', 'Can I talk with your team before subscribing?'),
                    answer: this.languageIndexer(
                        'Claro. Usa la seccion de contacto para coordinar apoyo o una orientacion rapida.',
                        'Absolutely. Use the contact section for support or a quick walkthrough.'
                    )
                }
            ],
            finalTitle: this.languageIndexer(
                'Cuando tus decisiones se sostienen con datos, tus resultados mejoran.',
                'When decisions are backed by data, outcomes improve.'
            ),
            finalPrimaryCta: this.languageIndexer('Explorar planes', 'Explore plans'),
            finalSecondaryCta: this.languageIndexer('Solicitar orientacion', 'Request guidance')
        };

        const localizedOverrides = variantKey === 'realtors' && selectedLanguage === 'english'
            ? {
                seo: {
                    path: '/realtor',
                    title: this.languageIndexer(
                        'CASADATA para Corredores y Brokers en Puerto Rico | Comparables, captacion y cierre',
                        'CASADATA for Real Estate Agents and Brokers in Puerto Rico | Comparables, listing acquisition, and closing'
                    ),
                    description: this.languageIndexer(
                        'Evalua comparables, Registro y riesgo para captar listings, fijar precio y cerrar con menos sorpresas en Puerto Rico.',
                        'Evaluate comparables, registry, permits, and risk to win listings, set price, and close with fewer surprises in Puerto Rico.'
                    ),
                    locale: selectedLanguage === 'english' ? 'en_US' : 'es_PR',
                    audienceLabel: this.languageIndexer('Corredores y Brokers', 'Real Estate Agents and Brokers')
                },
                navTagline: this.languageIndexer(
                    'Data y claridad para captar, listar y cerrar mejor',
                    'Data and clarity to win listings, list, and close better'
                ),
                heroKicker: this.languageIndexer(
                    'PARA CORREDORES Y BROKERS EN PUERTO RICO',
                    'FOR REAL ESTATE AGENTS AND BROKERS IN PUERTO RICO'
                ),
                heroTitle: this.languageIndexer(
                    <>
                        <span className='cdLpHeroTitleLine'>En Puerto Rico un listing no se gana solo con carisma.</span>
                        <span className='cdLpHeroTitleLine'>Se gana con comparables, criterio y menos sorpresas.</span>
                    </>,
                    <>
                        <span className='cdLpHeroTitleLine'>In Puerto Rico, you do not win a listing on charisma alone.</span>
                        <span className='cdLpHeroTitleLine'>You win it with comparables, judgment, and fewer surprises.</span>
                    </>
                ),
                heroSubtitle: this.languageIndexer(
                    'CASADATA te ayuda a establecer precio con mas sustento y darle al cliente una explicacion mas clara desde la captacion hasta el cierre.',
                    'CASADATA helps you set price with better support and give the client a clearer explanation from listing acquisition through closing.'
                ),
                proofWorkflow: this.languageIndexer(
                    'Captacion + pricing + ruta critica de cierre',
                    'Listing acquisition + pricing + closing critical path'
                ),
                proofUsedBy: this.languageIndexer(
                    'Corredores, brokers, equipos de ventas y profesionales inmobiliarios',
                    'Agents, brokers, sales teams, and real estate professionals'
                ),
                heroFinePrint: this.languageIndexer(
                    'Menos improvisacion. Mas confianza frente al cliente. Mejor control del proceso.',
                    'Less improvisation. More client confidence. Better control of the process.'
                ),
                overlayEyebrow: this.languageIndexer(
                    'CLARIDAD PARA CAPTAR Y CERRAR',
                    'CLARITY TO WIN LISTINGS AND CLOSE'
                ),
                overlayTitle: this.languageIndexer(
                    'Lo que un profesional inmobiliario necesita ver temprano para saber si una propiedad esta lista para listar, negociar y cerrar.',
                    'What a real estate professional needs to see early to know whether a property is ready to list, negotiate, and close.'
                ),
                overlayCopy: this.languageIndexer(
                    'Cuando precio, Registro y riesgo se leen antes, es mas facil inspirar confianza, evitar atrasos y defender cada recomendacion.',
                    'When price, registry, permits, and risk are read early, it becomes easier to build trust, avoid delays, and defend every recommendation.'
                ),
                overlayChips: [
                    this.languageIndexer('Captacion con mas certeza', 'Listing acquisition with more certainty'),
                    this.languageIndexer('Precio mejor sustentado', 'Better-supported pricing'),
                    this.languageIndexer('Cierre con menos retrasos', 'Closing with fewer delays')
                ],
                trustCards: [
                    {
                        title: this.languageIndexer('Captacion con mas confianza', 'Listing acquisition with more confidence'),
                        value: this.languageIndexer('Listings mejor preparados', 'Listings better prepared'),
                        description: this.languageIndexer(
                            'Identifica temprano senales de Registro o riesgo que pueden complicar la salida al mercado.',
                            'Identify early signals in registry, permits, or risk that can complicate bringing a property to market.'
                        )
                    },
                    {
                        title: this.languageIndexer('Precio con mejor sustento', 'Pricing with stronger support'),
                        value: this.languageIndexer('Comparables que aterrizan la conversacion', 'Comparables that ground the conversation'),
                        description: this.languageIndexer(
                            'Defiende rango de listado y expectativa aun en mercados con inventario visible limitado.',
                            'Defend listing range and expectations even in markets with limited visible inventory.'
                        )
                    },
                    {
                        title: this.languageIndexer('Cierre mas controlado', 'A more controlled closing'),
                        value: this.languageIndexer('Menos sorpresas en el proceso', 'Fewer surprises in the process'),
                        description: this.languageIndexer(
                            'Llega con mejor lectura para orientar al cliente, coordinar con terceros y mover la transaccion.',
                            'Come in with a better read to guide the client, coordinate with third parties, and move the transaction forward.'
                        )
                    }
                ],
                howTitle: this.languageIndexer(
                    'De captacion a cierre con menos friccion',
                    'From listing acquisition to closing with less friction'
                ),
                howSubtitle: this.languageIndexer(
                    'Pensado para el profesional que necesita listar con criterio, comunicar con claridad y anticipar problemas.',
                    'Built for the professional who needs to list with judgment, communicate clearly, and anticipate problems.'
                ),
                howSteps: [
                    {
                        title: this.languageIndexer('Evalua si la propiedad esta lista para salir', 'Assess whether the property is ready to go to market'),
                        description: this.languageIndexer(
                            'Revisa zona, comparables y senales de preparacion antes de prometer precio o tiempo de cierre.',
                            'Review area, comparables, and signs of documentary readiness before promising price or closing time.'
                        )
                    },
                    {
                        title: this.languageIndexer('Sustenta precio y expectativa', 'Support price and expectations'),
                        description: this.languageIndexer(
                            'Construye un CMA mas claro con contexto de inventario, ventas cerradas y condiciones que afectan la negociacion.',
                            'Build a clearer CMA with inventory context, closed sales, and conditions that affect negotiation.'
                        )
                    },
                    {
                        title: this.languageIndexer('Comparte evidencia y mueve el proceso', 'Share evidence and move the process'),
                        description: this.languageIndexer(
                            'Presenta visuales utiles para clientes, cooperadores, compradores remotos, notario o prestamista.',
                            'Present visuals that are useful for clients, cooperating agents, remote buyers, the notary, or the lender.'
                        )
                    }
                ],
                roleTitle: this.languageIndexer(
                    'Valor directo para la operacion del corredor en Puerto Rico',
                    "Direct value for the broker's operation in Puerto Rico"
                ),
                roleSubtitle: this.languageIndexer(
                    'Util en captacion, buyer rep, listings complejos y cierres donde la confianza vale tanto como el precio.',
                    'Useful in listing acquisition, buyer representation, complex listings, and closings where trust matters as much as price.'
                ),
                roleCards: [
                    {
                        title: this.languageIndexer('Captacion de listings con mas criterio', 'Listing acquisition with more judgment'),
                        description: this.languageIndexer(
                            'Llega a la cita con una lectura mas completa de precio, readiness y riesgo.',
                            'Walk into the appointment with a more complete read on price, readiness, and risk.'
                        )
                    },
                    {
                        title: this.languageIndexer('Claridad para clientes locales y diaspora', 'Clarity for local and diaspora clients'),
                        description: this.languageIndexer(
                            'Resume mejor el panorama para duenos, compradores remotos y familiares que necesitan entender rapido.',
                            'Summarize the situation better for owners, remote buyers, and relatives who need to understand quickly.'
                        )
                    },
                    {
                        title: this.languageIndexer('Seguimiento mas serio del cierre', 'A more serious closing follow-through'),
                        description: this.languageIndexer(
                            'Ordena conversaciones sobre Registro, tasacion, seguro y proximo paso.',
                            'Organize conversations about registry, permits, appraisal, insurance, and the next step.'
                        )
                    }
                ],
                demoTitle: this.languageIndexer(
                    'Mira como un profesional inmobiliario puede pasar de una propiedad a una recomendacion mas lista para cliente y cierre',
                    'See how a real estate professional can move from a property to a recommendation that is more ready for the client and for closing'
                ),
                demoSubtitle: this.languageIndexer(
                    'La demo ensena como convertir comparables, contexto y riesgo en una conversacion que transmite mas confianza.',
                    'The demo shows how to turn comparables, context, and risk into a conversation that builds more confidence.'
                ),
                evidenceTitle: this.languageIndexer(
                    'Por que corredores y brokers disciplinados usan CASADATA',
                    'Why disciplined agents and brokers use CASADATA'
                ),
                evidenceSubtitle: this.languageIndexer(
                    'Porque en Puerto Rico vender bien exige mas que mercadeo: exige evidencia, claridad y menos improvisacion.',
                    'Because in Puerto Rico, selling well requires more than marketing: it requires evidence, documentary clarity, and less improvisation.'
                ),
                evidenceCards: [
                    {
                        title: this.languageIndexer('Habla el idioma del proceso', 'Speak the language of the process'),
                        description: this.languageIndexer(
                            'Comparables, Registro de la Propiedad, tasacion y contexto de riesgo en una sola lectura.',
                            'Comparables, Property Registry, permits, appraisal, and risk context in a single read.'
                        )
                    },
                    {
                        title: this.languageIndexer('Data mas reciente', 'More current data'),
                        description: this.languageIndexer(
                            'Trabaja con informacion reciente para evitar sugerencias desfasadas frente al cliente.',
                            'Work with more recent information to avoid outdated guidance in front of the client.'
                        )
                    },
                    {
                        title: this.languageIndexer('Menos tiempo perdido', 'Less wasted time'),
                        description: this.languageIndexer(
                            'Reduce investigacion manual y enfoca tu energia en captar, explicar y cerrar.',
                            'Reduce manual research and focus your energy on winning listings, explaining, and closing.'
                        )
                    }
                ],
                faqItems: [
                    {
                        question: this.languageIndexer(
                            'Me ayuda a saber si una propiedad esta lista para listar?',
                            'Does it help me know whether a property is ready to list?'
                        ),
                        answer: this.languageIndexer(
                            'Si. Facilita una lectura inicial de precio, contexto, Registro, permisos y factores que pueden complicar la salida al mercado.',
                            'Yes. It provides an initial read on price, context, registry, permits, and factors that can complicate bringing the property to market.'
                        )
                    },
                    {
                        question: this.languageIndexer(
                            'Sirve para listings y para buyer representation?',
                            'Does it work for listings and buyer representation?'
                        ),
                        answer: this.languageIndexer(
                            'Si. Te ayuda a sustentar precio, orientar expectativas y negociar con mas evidencia a ambos lados de la transaccion.',
                            'Yes. It helps you support price, set expectations, and negotiate with stronger evidence on both sides of the transaction.'
                        )
                    },
                    {
                        question: this.languageIndexer(
                            'Puedo usarlo con clientes remotos o diaspora?',
                            'Can I use it with remote or diaspora clients?'
                        ),
                        answer: this.languageIndexer(
                            'Si. Las exportaciones y visuales ayudan a explicar mejor la propiedad a quien no esta presente en cada paso.',
                            'Yes. The exports and visuals help explain the property better to people who are not present at every step.'
                        )
                    },
                    {
                        question: this.languageIndexer(
                            'Ayuda a reducir atrasos en el cierre?',
                            'Does it help reduce delays at closing?'
                        ),
                        answer: this.languageIndexer(
                            'Ayuda a detectar temprano senales que suelen atrasar cierre, para que cliente y terceros entren mejor preparados.',
                            'It helps detect early signs that usually delay closing, so the client and third parties come in better prepared.'
                        )
                    }
                ],
                finalTitle: this.languageIndexer(
                    'En Puerto Rico el profesional que inspira mas confianza no es el que promete mas. Es el que llega con evidencia y anticipa mejor el camino al cierre.',
                    'In Puerto Rico, the professional who inspires more confidence is not the one who promises the most. It is the one who arrives with evidence and anticipates the road to closing more clearly.'
                ),
                finalPrimaryCta: this.languageIndexer(
                    'Ver planes para corredores y brokers',
                    'View plans for agents and brokers'
                ),
                finalSecondaryCta: this.languageIndexer(
                    'Hablar con un especialista',
                    'Talk to a specialist'
                )
            }
            : variantKey === 'inversionistas' && selectedLanguage === 'english'
            ? {
                seo: {
                    path: '/inversionistas',
                    title: this.languageIndexer(
                        'CASADATA para Inversionistas en Puerto Rico | Comparables, diligencia y criterio de compra',
                        'CASADATA for Investors in Puerto Rico | Comparables, diligence, and acquisition judgment'
                    ),
                    description: this.languageIndexer(
                        'Evalua comparables, CRIM, estatus registral, tasacion y salida potencial antes de comprometer capital en Puerto Rico.',
                        'Evaluate comparables, CRIM, registry status, appraisal, and exit potential before committing capital in Puerto Rico.'
                    ),
                    locale: selectedLanguage === 'english' ? 'en_US' : 'es_PR',
                    audienceLabel: this.languageIndexer('Inversionistas', 'Investors')
                },
                navTagline: this.languageIndexer(
                    'Capital disciplinado para oportunidades en Puerto Rico',
                    'Disciplined capital for Puerto Rico opportunities'
                ),
                heroKicker: this.languageIndexer(
                    'PARA INVERSIONISTAS QUE QUIEREN FILTRAR RUIDO Y PROTEGER CAPITAL',
                    'FOR INVESTORS WHO WANT TO FILTER NOISE AND PROTECT CAPITAL'
                ),
                heroTitle: this.languageIndexer(
                    <>
                        <span className='cdLpHeroTitleLine'>Comprar en Puerto Rico sin data es apostar.</span>
                        <span className='cdLpHeroTitleLine'>Con Casadata, es estrategia.</span>
                    </>,
                    <>
                        <span className='cdLpHeroTitleLine'>Buying in Puerto Rico without data is a bet.</span>
                        <span className='cdLpHeroTitleLine'>With Casadata, it becomes a strategy.</span>
                    </>
                ),
                heroSubtitle: this.languageIndexer(
                    'Valida precio, friccion y salida potencial antes de entrar. Negocia con evidencia y protege tu capital de errores caros.',
                    'Validate price, friction, and exit potential before you enter. Negotiate with evidence and protect your capital from expensive mistakes.'
                ),
                proofWorkflow: this.languageIndexer(
                    'Comparables + diligencia + oferta sustentada',
                    'Comparables + diligence + supported offer'
                ),
                proofUsedBy: this.languageIndexer(
                    'Inversionistas, equipos de adquisicion, brokers y socios',
                    'Investors, acquisitions teams, brokers, and partners'
                ),
                heroFinePrint: this.languageIndexer(
                    'Menos intuicion. Mas disciplina de compra. Mejor posicion para entrar, negociar y salir.',
                    'Less intuition. More acquisition discipline. Better position to enter, negotiate, and exit.'
                ),
                overlayEyebrow: this.languageIndexer(
                    'DILIGENCIA QUE REDUCE ERRORES CAROS',
                    'DILIGENCE THAT REDUCES EXPENSIVE ERRORS'
                ),
                overlayTitle: this.languageIndexer(
                    'Lo que un inversionista serio necesita ver temprano para distinguir una oportunidad real de una distraccion cara.',
                    'What a serious investor needs to see early to distinguish a real opportunity from an expensive distraction.'
                ),
                overlayCopy: this.languageIndexer(
                    'Precio, comparables, CRIM, estatus registral y contexto de riesgo deben leerse antes de mover evidencia de fondos o firmar una oferta.',
                    'Price, comparables, CRIM, registry status, and risk context should be read before sending proof of funds or signing an offer.'
                ),
                overlayChips: this.languageIndexer(
                    ['CASH ONLY con mas criterio', 'Entrada mejor sustentada', 'Salida mas defendible'],
                    ['CASH ONLY with more judgment', 'Better-supported entry', 'More defensible exit']
                ),
                trustCards: [
                    {
                        title: this.languageIndexer('Friccion identificada temprano', 'Friction identified early'),
                        value: this.languageIndexer('Menos capital atrapado', 'Less trapped capital'),
                        description: this.languageIndexer(
                            'Detecta senales de tasacion, Registro o riesgo territorial que pueden romper rendimiento, financiamiento o salida.',
                            'Detect appraisal, registry, or territorial-risk signals that can break returns, financing, or exit plans.'
                        )
                    },
                    {
                        title: this.languageIndexer('Precio mas defendible', 'More defensible pricing'),
                        value: this.languageIndexer('Menos hype, mas criterio', 'Less hype, more judgment'),
                        description: this.languageIndexer(
                            'Contrasta rango, liquidez y potencial de renta con ventas cerradas y micro-mercados reales.',
                            'Contrast range, liquidity, and rent potential against closed sales and real micro-markets.'
                        )
                    },
                    {
                        title: this.languageIndexer('Negociacion con ventaja', 'Negotiation with leverage'),
                        value: this.languageIndexer('Mejor posicion para ofertar', 'A better position to bid'),
                        description: this.languageIndexer(
                            'Llega con evidencia para hablar con corredor, vendedor, socio, comite o prestamista sin improvisar.',
                            'Show up with evidence for conversations with brokers, sellers, partners, committees, or lenders without improvising.'
                        )
                    }
                ],
                howTitle: this.languageIndexer(
                    'De lead atractivo a compra disciplinada',
                    'From attractive lead to disciplined acquisition'
                ),
                howSubtitle: this.languageIndexer(
                    'Pensado para el inversionista que quiere filtrar rapido, profundizar con criterio y mover capital solo cuando la tesis aguanta.',
                    'Built for investors who want to filter quickly, go deeper with judgment, and move capital only when the thesis holds.'
                ),
                howSteps: [
                    {
                        title: this.languageIndexer('Filtra lo que merece tu tiempo', 'Filter what deserves your time'),
                        description: this.languageIndexer(
                            'Define mercado, activo y rango para descartar rapido lo que no cumple tu buy box.',
                            'Define market, asset, and range to quickly discard anything that does not fit your buy box.'
                        )
                    },
                    {
                        title: this.languageIndexer('Valida valor y friccion real', 'Validate value and real friction'),
                        description: this.languageIndexer(
                            'Contrasta AS IS, CASH ONLY, renta potencial y contexto de riesgo frente a ventas cerradas y lectura local.',
                            'Contrast AS IS, CASH ONLY, rent potential, and risk context against closed sales and local market reading.'
                        )
                    },
                    {
                        title: this.languageIndexer('Oferta con base, no con impulso', 'Make the offer from evidence, not impulse'),
                        description: this.languageIndexer(
                            'Exporta evidencia y entra a la conversacion con mejor sustento para negociar termino, precio y velocidad de cierre.',
                            'Export evidence and enter the conversation with a stronger basis to negotiate terms, price, and closing speed.'
                        )
                    }
                ],
                roleTitle: this.languageIndexer(
                    'Valor directo para comprar con mas criterio en Puerto Rico',
                    'Direct value for buying with better judgment in Puerto Rico'
                ),
                roleSubtitle: this.languageIndexer(
                    'Util para buy and hold, multifamiliar, value-add y oportunidades donde la entrada importa tanto como la salida.',
                    'Useful for buy-and-hold, multifamily, value-add, and opportunities where entry matters as much as exit.'
                ),
                roleCards: [
                    {
                        title: this.languageIndexer('Filtro inicial con mas disciplina', 'A more disciplined first filter'),
                        description: this.languageIndexer(
                            'Sabes temprano si precio, zona y friccion justifican visitas, diligencia y evidencia de fondos.',
                            'Know early whether price, location, and friction justify visits, diligence, and proof of funds.'
                        )
                    },
                    {
                        title: this.languageIndexer('Lectura mas seria del mercado', 'A more serious market read'),
                        description: this.languageIndexer(
                            'Aterriza comparables, tendencia y potencial con contexto local, no con entusiasmo prestado.',
                            'Ground comps, trend, and potential in local context, not borrowed enthusiasm.'
                        )
                    },
                    {
                        title: this.languageIndexer('Soporte listo para socios y credito', 'Support ready for partners and credit'),
                        description: this.languageIndexer(
                            'Lleva evidencia clara a conversaciones con socios, comites, corredores o prestamistas.',
                            'Bring clear evidence to conversations with partners, committees, brokers, or lenders.'
                        )
                    }
                ],
                demoTitle: this.languageIndexer(
                    'Mira como un inversionista puede separar rapido una oportunidad real de una distraccion cara',
                    'See how an investor can quickly separate a real opportunity from an expensive distraction'
                ),
                demoSubtitle: this.languageIndexer(
                    'La demo ensena como usar comparables, contexto y exportaciones para filtrar, validar y negociar con mas disciplina.',
                    'The demo shows how to use comparables, context, and exports to filter, validate, and negotiate with more discipline.'
                ),
                evidenceTitle: this.languageIndexer(
                    'Por que los inversionistas mas disciplinados se apoyan en CASADATA',
                    'Why the most disciplined investors lean on CASADATA'
                ),
                evidenceSubtitle: this.languageIndexer(
                    'Porque en Puerto Rico comprar bien exige data dificil de reunir, contexto local y una lectura mas sobria antes de comprometer capital.',
                    'Because buying well in Puerto Rico requires hard-to-assemble data, local context, and a more sober read before committing capital.'
                ),
                evidenceCards: [
                    {
                        title: this.languageIndexer('Habla el idioma del underwriting', 'Speak the language of underwriting'),
                        description: this.languageIndexer(
                            'Comparables, CRIM, Registro, tendencia y contexto territorial en una sola lectura.',
                            'Comparables, CRIM, registry, trend, and territorial context in a single reading.'
                        )
                    },
                    {
                        title: this.languageIndexer('Actualizacion que acorta reaccion', 'Updates that shorten reaction time'),
                        description: this.languageIndexer(
                            'Trabaja con data reciente para no llegar tarde ni pagar de mas por una narrativa bonita.',
                            'Work with recent data so you do not arrive late or overpay for a pretty narrative.'
                        )
                    },
                    {
                        title: this.languageIndexer('Material listo para comites y socios', 'Material ready for committees and partners'),
                        description: this.languageIndexer(
                            'Exporta evidencia para ofertas, financiamiento, analisis interno y conversaciones de diligencia.',
                            'Export evidence for offers, financing, internal analysis, and diligence conversations.'
                        )
                    }
                ],
                faqItems: [
                    {
                        question: this.languageIndexer(
                            'Me ayuda a saber si un CASH ONLY / AS IS justifica seguir adelante?',
                            'Does it help me tell whether a CASH ONLY / AS IS deal justifies moving forward?'
                        ),
                        answer: this.languageIndexer(
                            'Si. Permite contrastar precio y contexto antes de invertir mas tiempo en visitas, evidencia de fondos y diligencia.',
                            'Yes. It lets you contrast price and context before investing more time in visits, proof of funds, and diligence.'
                        )
                    },
                    {
                        question: this.languageIndexer(
                            'Sirve para buy & hold, multifamiliar, flip o rentas a largo plazo?',
                            'Does it work for buy-and-hold, multifamily, flips, or long-term rentals?'
                        ),
                        answer: this.languageIndexer(
                            'Si. Apoya estrategias donde cash flow, valor de reventa y potencial de salida deben quedar mejor sustentados.',
                            'Yes. It supports strategies where cash flow, resale value, and exit potential need to be better supported.'
                        )
                    },
                    {
                        question: this.languageIndexer(
                            'Puedo usarlo para negociar mejor con corredores, vendedores o prestamistas?',
                            'Can I use it to negotiate better with brokers, sellers, or lenders?'
                        ),
                        answer: this.languageIndexer(
                            'Si. Llegas con comparables, rango y preguntas mas precisas.',
                            'Yes. You arrive with comps, range, and more precise questions.'
                        )
                    },
                    {
                        question: this.languageIndexer(
                            'Me ayuda a decidir si una propiedad merece visita, evidencia de fondos o distancia?',
                            'Can it help me decide whether a property deserves a visit, proof of funds, or distance?'
                        ),
                        answer: this.languageIndexer(
                            'Si. Te ayuda a filtrar temprano que vale seguimiento y que probablemente solo te consumira tiempo y enfoque.',
                            'Yes. It helps you filter early what deserves follow-through and what will probably only consume time and focus.'
                        )
                    }
                ],
                finalTitle: this.languageIndexer(
                    'En Puerto Rico las mejores compras no siempre son las que mas llaman la atencion. Son las que resisten la diligencia antes de pedirte capital.',
                    'In Puerto Rico, the best acquisitions are not always the ones that attract the most attention. They are the ones that withstand diligence before asking for your capital.'
                ),
                finalPrimaryCta: this.languageIndexer(
                    'Ver planes para inversionistas',
                    'View plans for investors'
                ),
                finalSecondaryCta: this.languageIndexer(
                    'Hablar con un especialista',
                    'Talk to a specialist'
                )
            }
            : overrides;

        return {
            ...defaultCopy,
            ...localizedOverrides,
            seo: {
                ...defaultCopy.seo,
                ...(localizedOverrides.seo || {})
            },
            overlayChips: localizedOverrides.overlayChips || defaultCopy.overlayChips,
            trustCards: localizedOverrides.trustCards || defaultCopy.trustCards,
            howSteps: localizedOverrides.howSteps || defaultCopy.howSteps,
            roleCards: localizedOverrides.roleCards || defaultCopy.roleCards,
            evidenceCards: localizedOverrides.evidenceCards || defaultCopy.evidenceCards,
            faqItems: localizedOverrides.faqItems || defaultCopy.faqItems
        };
    }

    getLandingSeoData(landingCopy) {
        const seo = landingCopy.seo || {};
        const canonicalPath = String(seo.path || '/');
        const canonicalUrl = `${LANDING_SITE_ORIGIN}${canonicalPath}`;
        const imageUrl = `${LANDING_SITE_ORIGIN}/android-chrome-512x512.png`;
        const faqEntities = (landingCopy.faqItems || []).map((item) => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer
            }
        }));
        const schemaGraph = [
            {
                '@context': 'https://schema.org',
                '@type': 'WebPage',
                name: seo.title,
                description: seo.description,
                url: canonicalUrl,
                inLanguage: seo.locale === 'en_US' ? 'en-US' : 'es-PR',
                about: seo.audienceLabel || 'CASADATA'
            },
            {
                '@context': 'https://schema.org',
                '@type': 'SoftwareApplication',
                name: 'CASADATA',
                applicationCategory: 'BusinessApplication',
                operatingSystem: 'Web',
                url: canonicalUrl,
                description: seo.description,
                areaServed: {
                    '@type': 'AdministrativeArea',
                    name: 'Puerto Rico'
                }
            },
            {
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: faqEntities
            }
        ];

        return {
            canonicalUrl,
            imageUrl,
            schemaJson: JSON.stringify(schemaGraph).replace(/</g, '\\u003c'),
            ...seo
        };
    }

    renderLandingHelmet(landingCopy) {
        const seo = this.getLandingSeoData(landingCopy);

        return (
            <Helmet>
                <html lang={seo.locale === 'en_US' ? 'en' : 'es'} />
                <title>{seo.title}</title>
                <meta name='description' content={seo.description} />
                <meta name='robots' content='index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1' />
                <link rel='canonical' href={seo.canonicalUrl} />
                <link rel='alternate' hrefLang='es-pr' href={seo.canonicalUrl} />
                <link rel='alternate' hrefLang='x-default' href={`${LANDING_SITE_ORIGIN}/`} />
                <meta property='og:type' content='website' />
                <meta property='og:site_name' content='CASADATA' />
                <meta property='og:url' content={seo.canonicalUrl} />
                <meta property='og:title' content={seo.title} />
                <meta property='og:description' content={seo.description} />
                <meta property='og:image' content={seo.imageUrl} />
                <meta property='og:locale' content={seo.locale || 'es_PR'} />
                <meta name='twitter:card' content='summary_large_image' />
                <meta name='twitter:title' content={seo.title} />
                <meta name='twitter:description' content={seo.description} />
                <meta name='twitter:image' content={seo.imageUrl} />
                <script
                    type='application/ld+json'
                    dangerouslySetInnerHTML={{ __html: seo.schemaJson }}
                />
            </Helmet>
        );
    }

    sendLandingAnalytics(eventName, details = {}) {
        const eventLabel = this.cleanAnalyticsValue(eventName, 32);
        const payload = { sid: this.landingSessionId, ...details };
        const detailTokens = Object.entries(payload)
            .filter(([, value]) => value !== undefined && value !== null && value !== '')
            .map(([key, value]) => `${this.cleanAnalyticsValue(key, 10)}:${this.cleanAnalyticsValue(value, 26)}`)
            .slice(0, 6);
        const action = detailTokens.length > 0 ? `${eventLabel}|${detailTokens.join(',')}` : eventLabel;
        sendAnalytics('LANDING', action, String(new Date()));
    }

    startLandingSession(reason = 'enter_main') {
        this.landingSessionId = `fp_${Date.now()}_${Math.random().toString(16).slice(2, 8)}`;
        this.landingSessionStartTs = Date.now();
        this.landingMaxScroll = 0;
        this.landingLastSection = 'hero';
        this.landingScrollMilestonesSeen = new Set();
        this.landingSectionSeen = new Set();
        this.landingExitSent = false;

        this.sendLandingAnalytics('SESSION_START', {
            reason,
            route: this.state.contentIndex,
            vw: this.getViewportBucket(),
            lang: this.getLanguageBucket(),
            sid: this.landingSessionId
        });
    }

    captureLandingScroll() {
        if (!this.mainContainer || this.state.contentIndex !== 'main') return;

        const maxScrollable = this.mainContainer.scrollHeight - this.mainContainer.clientHeight;
        const progress = maxScrollable <= 0 ? 100 : Math.round((this.mainContainer.scrollTop / maxScrollable) * 100);
        const boundedProgress = Math.max(0, Math.min(100, progress));
        this.mainContainer.style.setProperty('--landing-scroll-progress', String(boundedProgress));

        if (boundedProgress > this.landingMaxScroll) {
            this.landingMaxScroll = boundedProgress;
        }

        LANDING_SCROLL_MILESTONES.forEach((milestone) => {
            if (boundedProgress >= milestone && !this.landingScrollMilestonesSeen.has(milestone)) {
                this.landingScrollMilestonesSeen.add(milestone);
                this.sendLandingAnalytics('SCROLL_MILESTONE', {
                    pct: milestone,
                    sec: this.landingLastSection
                });
            }
        });
    }

    armLandingMotion() {
        if (!this.mainContainer) return;
        this.mainContainer.setAttribute('data-motion', 'armed');
        this.mainContainer.style.setProperty('--landing-scroll-progress', '0');
    }

    markLandingSectionVisible(sectionNode) {
        if (!sectionNode) return;
        sectionNode.classList.add('is-visible');
    }

    setupLandingObserver() {
        if (!this.mainContainer || this.landingObserver) return;
        const sections = Array.from(this.mainContainer.querySelectorAll('[data-landing-section]'));
        if (!sections.length) return;

        if (typeof IntersectionObserver === 'undefined') {
            sections.forEach((sectionNode) => this.markLandingSectionVisible(sectionNode));
            return;
        }

        this.landingObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const section = entry.target.getAttribute('data-landing-section') || 'unknown';
                this.landingLastSection = section;
                this.markLandingSectionVisible(entry.target);

                if (entry.intersectionRatio >= 0.45 && !this.landingSectionSeen.has(section)) {
                    this.landingSectionSeen.add(section);
                    this.sendLandingAnalytics('SECTION_VIEW', {
                        sec: section,
                        pct: this.landingMaxScroll
                    });
                }
            });
        }, {
            root: this.mainContainer,
            threshold: [0.2, 0.45, 0.7]
        });

        sections.forEach((sectionNode) => this.landingObserver.observe(sectionNode));
    }

    teardownLandingObserver() {
        if (this.landingObserver) {
            this.landingObserver.disconnect();
            this.landingObserver = null;
        }
    }

    attachLandingListeners() {
        if (this.landingListenersAttached) return;
        if (this.mainContainer) {
            this.mainContainer.addEventListener('scroll', this.handleLandingScroll, { passive: true });
        }
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        this.landingListenersAttached = true;
    }

    detachLandingListeners() {
        if (!this.landingListenersAttached) return;
        if (this.mainContainer) {
            this.mainContainer.removeEventListener('scroll', this.handleLandingScroll);
        }
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        this.landingListenersAttached = false;
    }

    captureLandingExit(cause = 'leave_main') {
        if (this.landingExitSent || !this.landingSessionStartTs) return;
        this.landingExitSent = true;
        const dwellSec = Math.max(0, Math.round((Date.now() - this.landingSessionStartTs) / 1000));

        this.sendLandingAnalytics('SESSION_END', {
            cause,
            dwell: dwellSec,
            max: this.landingMaxScroll,
            sec: this.landingLastSection,
            seen: this.landingSectionSeen.size
        });
    }

    handleLandingRouteChange(prevRoute, nextRoute) {
        this.sendLandingAnalytics('ROUTE_CHANGE', { from: prevRoute || 'na', to: nextRoute || 'na' });

        if (prevRoute === 'main' && nextRoute !== 'main') {
            this.captureLandingExit(`to_${nextRoute}`);
            this.detachLandingListeners();
            this.teardownLandingObserver();
        }

        if (nextRoute === 'main' && prevRoute !== 'main') {
            this.mainContainer = document.getElementById("mainContainer");
            this.armLandingMotion();
            this.startLandingSession(`from_${prevRoute || 'na'}`);
            this.attachLandingListeners();
            this.setupLandingObserver();
            this.captureLandingScroll();
        }
    }

    trackFrontpageView(routeIndex) {
        const route = String(routeIndex || 'main');
        const variantKey = this.getLandingVariantKey();
        const pageTitle =
            route === 'prices' ? 'Pricing Page' :
            route === 'contact' ? 'Contact Page' :
            route === 'person' ? 'Auth Choice Page' :
            (variantKey === 'realtors' ? 'Realtors Landing Page' :
                variantKey === 'tasadores' ? 'Appraisers Landing Page' :
                    variantKey === 'inversionistas' ? 'Investors Landing Page' :
                        'Front Page');

        trackPageView(pageTitle, { frontpage_route: route, landing_variant: variantKey });
        this.sendLandingAnalytics('ROUTE_VIEW', {
            route,
            vw: this.getViewportBucket(),
            lang: this.getLanguageBucket(),
            aud: variantKey
        });
    }

    trackPricingPixelView(source = 'frontpage') {
        const seatPrices = this.state?.seatInfo?.current_prices || {};
        const monthly = Number(seatPrices.monthly ?? paymentConfig.plusMaxMonthly);
        const annual = Number(seatPrices.annual ?? paymentConfig.plusMaxYearly);
        const billingCycle = this.state.plusMaxBilling === 'annual' ? 'annual' : 'monthly';
        const value = billingCycle === 'annual' ? annual : monthly;

        track('ViewContent', {
            content_name: 'PlusMAX Pricing',
            content_type: 'product',
            content_category: 'subscription',
            value,
            currency: 'USD',
            billing_cycle: billingCycle,
            source
        });
    }

    componentDidMount() {
        this.isFrontpageUnmounted = false;
        this.mainContainer = document.getElementById("mainContainer");
        this.armLandingMotion();
        this.ensureHeroPreloadLink();
        const runHeroFreshnessFetch = () => {
            if (this.isFrontpageUnmounted) return;
            if (typeof window.requestIdleCallback === 'function') {
                this.heroFreshnessIdleHandle = window.requestIdleCallback(() => {
                    this.heroFreshnessIdleHandle = null;
                    this.fetchHeroFreshness();
                }, { timeout: 4000 });
            } else {
                this.fetchHeroFreshness();
            }
        };
        if (window.innerWidth < 780) {
            this.heroFreshnessTimer = window.setTimeout(runHeroFreshnessFetch, 9000);
        } else {
            this.fetchHeroFreshness();
        }
        window.addEventListener('resize', this.handleResizeWindow)
        window.addEventListener('resize', this.handleResizeScatter)
        this.adjustWindowSize()
        if (this.state.contentIndex === 'main') {
            this.startLandingSession('mount');
            this.attachLandingListeners();
            this.setupLandingObserver();
            this.captureLandingScroll();
        }
        this.trackFrontpageView(this.state.contentIndex);
        if(this.state.isIos){
            this.setState({videoDarkenClass:'videoLighten'})
        }
        this.props.userSelectedMonthly && this.props.userSelectedMonthly();
        this.setState({ plusMaxBilling: 'monthly' });

        try{document.querySelector('#movie_player > div.ytp-chrome-top.ytp-show-cards-title').style='display:None;'}catch{}
        this.scatterStyleIndexer()
        // ? If App wants us to land on Prices immediately
        if (this.state.contentIndex === 'prices') {
            // ensure seat status loads even if we started on prices (no contentIndex transition)
            trackCustom('ViewPricing', { reason: this.props.landingReason || '', src: this.props.landingSrc || '' });
            this.trackPricingPixelView('auto_landing');
            trackEvent('view_pricing', {
                reason: this.props.landingReason || 'upgrade',
                source: this.props.landingSrc || 'auto_landing'
            });
            trackViewItemList({ source: 'auto_landing' });
            this.fetchPlusMaxSeatStatus();
            this.fetchPricingTrialEligibility();
        
            // optional analytics
            sendAnalytics("PRICES", `AUTO_LAND_${String(this.props.landingReason || "upgrade").toUpperCase()}`, String(new Date()));
        
            // let App clear the forcing flag
            try { this.props.onLandingHandled && this.props.onLandingHandled(); } catch {}
        }

        const handoffTopicPage = this.getSeoTopicPage();
        // Stats pages are destinations, not doorways: they keep their embedded
        // interactive charts instead of handing off to the generic landing.
        if (this.state.contentIndex === 'main' && handoffTopicPage && !handoffTopicPage.statsEmbed) {
            this.seoTopicSwitchTimer = window.setTimeout(() => {
                if (this.isFrontpageUnmounted) return;

                this.setState({ seoTopicHold: false }, () => {
                    this.teardownLandingObserver();
                    this.detachLandingListeners();
                    this.mainContainer = document.getElementById("mainContainer");
                    this.armLandingMotion();
                    this.attachLandingListeners();
                    this.setupLandingObserver();
                    this.captureLandingScroll();
                });
            }, SEO_TOPIC_HANDOFF_DELAY_MS);
        }

        const enableChatbot = () => {
            if (!this.isFrontpageUnmounted) {
                this.setState({ enableChatbot: true });
            }
            this.chatbotIdleHandle = null;
        };
        const scheduleChatbot = () => {
            if (typeof window.requestIdleCallback === 'function') {
                this.chatbotIdleHandle = window.requestIdleCallback(enableChatbot, { timeout: 2500 });
            } else {
                enableChatbot();
            }
        };
        const chatbotDelay = window.innerWidth < 780 ? 12000 : 2600;
        this.chatbotTimer = window.setTimeout(scheduleChatbot, chatbotDelay);
  
    }

    componentWillUnmount() {
        this.isFrontpageUnmounted = true;
        this.cleanupTrialEligibilityBridge();
        this.captureLandingExit('unmount');
        this.detachLandingListeners();
        this.teardownLandingObserver();
        window.removeEventListener('resize', this.handleResizeWindow);
        window.removeEventListener('resize', this.handleResizeScatter);
        if (this.seoTopicSwitchTimer) {
            window.clearTimeout(this.seoTopicSwitchTimer);
            this.seoTopicSwitchTimer = null;
        }
        if (this.heroFreshnessTimer) {
            window.clearTimeout(this.heroFreshnessTimer);
            this.heroFreshnessTimer = null;
        }
        if (this.heroFreshnessIdleHandle && typeof window.cancelIdleCallback === 'function') {
            window.cancelIdleCallback(this.heroFreshnessIdleHandle);
            this.heroFreshnessIdleHandle = null;
        }
        if (this.chatbotTimer) {
            window.clearTimeout(this.chatbotTimer);
            this.chatbotTimer = null;
        }
        if (this.chatbotIdleHandle && typeof window.cancelIdleCallback === 'function') {
            window.cancelIdleCallback(this.chatbotIdleHandle);
            this.chatbotIdleHandle = null;
        }
    }

    componentDidUpdate(prevProps, prevState){
        // ? If App tells us to go to Prices after we already mounted
        if (prevProps && prevProps.landingTarget !== this.props.landingTarget) {
            if (this.props.landingTarget === 'prices' && this.state.contentIndex !== 'prices') {
            this.setState({ contentIndex: 'prices' }, () => {
                try { this.props.onLandingHandled && this.props.onLandingHandled(); } catch {}
            });
            }
        }
        if (prevState && prevState.contentIndex !== this.state.contentIndex) {
            this.handleLandingRouteChange(prevState.contentIndex, this.state.contentIndex);
            this.trackFrontpageView(this.state.contentIndex);
        }
        try{document.querySelector('#movie_player > div.ytp-chrome-top.ytp-show-cards-title').style='display:None;'}catch{}
        // When user navigates to Prices, load seat status once
        if (prevState && prevState.contentIndex !== this.state.contentIndex) {
            if (this.state.contentIndex === 'prices') {
                trackCustom('ViewPricing', {
                  plan: 'PlusMAX',
                  reason: this.props.landingReason || '',
                  src: this.props.landingSrc || ''
                });
                this.trackPricingPixelView('frontpage_navigation');
                trackEvent('view_pricing', {
                    reason: this.props.landingReason || 'navigation',
                    source: this.props.landingSrc || 'frontpage_navigation'
                });
                trackViewItemList({ source: 'frontpage_navigation' });
                this.fetchPlusMaxSeatStatus();
                this.fetchPricingTrialEligibility();
              }              
        }
    }
    
    fetchPlusMaxSeatStatus = () => {
        if (!this.state.serverIp) return;
    
        this.setState({ seatLoading: true, seatError: '' });
    
        fetch(`${this.state.serverIp}/api/plusmaxSeatStatus`, { method: 'GET' })
            .then(r => r.json())
            .then(data => {
                this.setState({ seatLoading: false, seatInfo: data });
                trackEvent('pricing_seat_status_loaded', {
                    sold_out: Boolean(data?.sold_out),
                    seats_remaining: Number(data?.seats_remaining || 0)
                });
            })
            .catch(err => {
                this.setState({ seatLoading: false, seatError: String(err) });
                trackEvent('pricing_seat_status_failed');
            });
    };

    setPricingTrialState(nextState = {}) {
        if (this.isFrontpageUnmounted) return;
        this.setState(nextState);
    }

    cleanupTrialEligibilityBridge = () => {
        if (typeof this.trialEligibilityBridgeCleanup === 'function') {
            try {
                this.trialEligibilityBridgeCleanup();
            } catch {}
        }
        this.trialEligibilityBridgeCleanup = null;
    };

    getCustomerFingerprint = async () => {
        const inheritedFingerprint = String(this.props.fingerprint || '').trim();
        if (inheritedFingerprint) {
            return inheritedFingerprint;
        }

        if (this.customerFingerprintPromise) {
            return this.customerFingerprintPromise;
        }

        this.customerFingerprintPromise = (async () => {
            const fingerprintModule = await import('@fingerprintjs/fingerprintjs');
            const FingerprintJS = fingerprintModule.default || fingerprintModule;
            const fpAgent = await FingerprintJS.load();
            const fpResult = await Promise.race([
                fpAgent.get(),
                new Promise((_, reject) => {
                    window.setTimeout(() => reject(new Error('fingerprint_timeout')), 8000);
                })
            ]);
            const visitorId = String(fpResult?.visitorId || '').trim();

            if (!visitorId) {
                throw new Error('fingerprint_unavailable');
            }

            return visitorId;
        })();

        try {
            return await this.customerFingerprintPromise;
        } catch (error) {
            this.customerFingerprintPromise = null;
            throw error;
        }
    };

    getVerifiedPricingTrialEligibility = (customerFingerprint = '') => {
        const baseUrl = String(this.state.serverIp || '').replace(/\/+$/, '');
        if (!baseUrl || typeof window === 'undefined' || typeof document === 'undefined') {
            return Promise.reject(new Error('trial_bridge_unavailable'));
        }

        return new Promise((resolve, reject) => {
            this.cleanupTrialEligibilityBridge();

            let settled = false;
            let timerId = null;
            let iframe = null;
            let bridgeOrigin = '';

            try {
                bridgeOrigin = new URL(baseUrl).origin;
            } catch {}

            const channel = `pricing_trial_${Date.now()}_${Math.random().toString(16).slice(2, 10)}`;

            const handleMessage = (event) => {
                if (settled) return;
                if (bridgeOrigin && event.origin !== bridgeOrigin) return;

                const payload = event.data || {};
                if (payload.type !== 'casadata_trial_eligibility' || payload.channel !== channel) {
                    return;
                }

                settled = true;
                cleanup();
                resolve(payload);
            };

            const cleanup = () => {
                if (timerId) {
                    window.clearTimeout(timerId);
                    timerId = null;
                }
                window.removeEventListener('message', handleMessage);
                if (iframe && iframe.parentNode) {
                    iframe.parentNode.removeChild(iframe);
                }
                iframe = null;
                if (this.trialEligibilityBridgeCleanup === cleanup) {
                    this.trialEligibilityBridgeCleanup = null;
                }
            };

            window.addEventListener('message', handleMessage);
            this.trialEligibilityBridgeCleanup = cleanup;

            timerId = window.setTimeout(() => {
                if (settled) return;
                settled = true;
                cleanup();
                reject(new Error('trial_eligibility_bridge_timeout'));
            }, 15000);

            iframe = document.createElement('iframe');
            iframe.setAttribute('aria-hidden', 'true');
            iframe.tabIndex = -1;
            iframe.style.position = 'absolute';
            iframe.style.width = '0';
            iframe.style.height = '0';
            iframe.style.border = '0';
            iframe.style.opacity = '0';
            iframe.style.pointerEvents = 'none';

            const params = new URLSearchParams();
            params.set('channel', channel);
            if (customerFingerprint) {
                params.set('customerFingerprint', customerFingerprint);
            }
            iframe.src = `${baseUrl}/api/trialEligibilityBridge?${params.toString()}`;

            const mountNode = document.body || document.documentElement;
            if (!mountNode) {
                settled = true;
                cleanup();
                reject(new Error('trial_bridge_mount_failed'));
                return;
            }

            mountNode.appendChild(iframe);
        });
    };

    fetchPricingTrialEligibility = async () => {
        if (!this.state.serverIp || this.trialEligibilityPending === true) return;
        if (this.state.trialOfferVisibility === 'visible' || this.state.trialOfferVisibility === 'hidden') return;

        this.trialEligibilityPending = true;

        const parseJsonSafe = async (response) => {
            try {
                return await response.json();
            } catch {
                return {};
            }
        };

        const hideTrialOffer = (reason = 'trial_ineligible') => {
            this.setPricingTrialState({
                trialOfferVisibility: 'hidden',
                trialEligibilityReason: String(reason || 'trial_ineligible'),
                trialEligibilityRid: '',
                trialEligibilityFingerprint: ''
            });
            try {
                trackEvent('pricing_trial_offer_hidden', {
                    reason: String(reason || 'trial_ineligible')
                });
            } catch {}
        };

        try {
            let customerFingerprint = '';
            try {
                customerFingerprint = await this.getCustomerFingerprint();
            } catch {
                hideTrialOffer('fingerprint_unavailable');
                return;
            }

            const deviceProbeResponse = await fetch(`${this.state.serverIp}/api/trialEligibility`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ customerFingerprint })
            });
            const deviceProbe = await parseJsonSafe(deviceProbeResponse);
            if (deviceProbe?.eligible === false) {
                hideTrialOffer(String(deviceProbe?.reason || 'trial_used'));
                return;
            }

            if (deviceProbe?.eligible !== true) {
                hideTrialOffer(String(deviceProbe?.reason || 'trial_ineligible'));
                return;
            }

            this.setPricingTrialState({
                trialOfferVisibility: 'visible',
                trialEligibilityReason: String(deviceProbe?.reason || 'eligible'),
                trialEligibilityRid: '',
                trialEligibilityFingerprint: customerFingerprint
            });
        } catch {
            hideTrialOffer('probe_error');
        } finally {
            this.trialEligibilityPending = false;
        }
    };
    

    adjustWindowSize(){
        if(window.innerWidth<390){
            this.setState({windowTooSmallAdjustClass:'smallScreen',lowerAdjustClass:'smallScreenLow',scrollUpper:1670,lowerBtn:'lowerBtnSmall'})
        }
        else if(window.innerWidth>=390&&window.innerWidth<=579){
            this.setState({windowTooSmallAdjustClass:'midScreen',lowerAdjustClass:'midScreenLow',scrollUpper:1460,lowerBtn:'lowerBtnMid'})
        }
        else{
            this.setState({windowTooSmallAdjustClass:'largeScreen',lowerAdjustClass:'largeScreenLow',scrollUpper:1160,lowerBtn:'lowerBtnLarge'})
        }
    }

    scrollWindowSize(){
        if(window.innerWidth<390){
            document.querySelector('#mainContainer').scrollTo({
                top: 2250,
                behavior: 'smooth'
            });
        }
        else if(window.innerWidth>=390&&window.innerWidth<=579){
            document.querySelector('#mainContainer').scrollTo({
                top: 2100,
                behavior: 'smooth'
            });
        }
        else{
            document.querySelector('#mainContainer').scrollTo({
                top: 1700,
                behavior: 'smooth'
            });
        }
    }

    handleScroll = () => {
        if(this.mainContainer.scrollTop>=170){this.setState({showFirstContent:true})};
        if(this.mainContainer.scrollTop>=500){this.setState({showSecondContent:true})};
    }   

    formatMoney = (value) => {
        const num = Number(value);
        if (!Number.isFinite(num)) return String(value);
      
        const isInt = Math.abs(num - Math.round(num)) < 0.000001;
        return num.toLocaleString(undefined, {
          minimumFractionDigits: isInt ? 0 : 2,
          maximumFractionDigits: isInt ? 0 : 2
        });
      };
      
      selectPlusMaxBilling = (billing) => {
        if (billing === this.state.plusMaxBilling) return;

        const seatPrices = this.state?.seatInfo?.current_prices || {};
        const monthly = Number(seatPrices.monthly ?? paymentConfig.plusMaxMonthly);
        const annual = Number(seatPrices.annual ?? paymentConfig.plusMaxYearly);
        const selectedValue = billing === 'monthly' ? monthly : annual;
      
        if (billing === 'monthly') {
          this.props.userSelectedMonthly && this.props.userSelectedMonthly();
          sendAnalytics("PRICING_PLAN", "PlusMAX Monthly Selected", String(new Date()));
        } else {
          this.props.userSelectedAnnual && this.props.userSelectedAnnual();
          sendAnalytics("PRICING_PLAN", "PlusMAX Annual Selected", String(new Date()));
        }

        trackEvent('select_item', {
          item_name: 'PlusMAX',
          item_category: 'subscription',
          billing_cycle: billing,
          value: selectedValue,
          currency: 'USD',
          source: 'pricing_toggle'
        });
        trackCustom('PricingBillingSelected', {
          plan: 'PlusMAX',
          billing_cycle: billing,
          value: selectedValue
        });
      
        this.setState({ plusMaxBilling: billing });
      };

      selectProBilling = (billing) => {
        if (billing === this.state.proBilling) return;

        const selectedValue = billing === 'monthly'
          ? paymentConfig.plusMaxProMonthly
          : paymentConfig.plusMaxProYearly;

        sendAnalytics("PRICING_PLAN", `PlusMAX Pro ${billing === 'monthly' ? 'Monthly' : 'Annual'} Selected`, String(new Date()));
        trackEvent('select_item', {
          item_name: 'PlusMAXPro',
          item_category: 'subscription',
          billing_cycle: billing,
          value: selectedValue,
          currency: 'USD',
          source: 'pricing_toggle'
        });
        trackCustom('PricingBillingSelected', {
          plan: 'PlusMAXPro',
          billing_cycle: billing,
          value: selectedValue
        });

        this.setState({ proBilling: billing });
      };


    ponemosIndexer(){
        if(window.innerWidth>1020){
            return(
                <div
                style={{
                    color:"#024a99",
                    fontSize:'180%',
                    fontFamily:'Roboto',
                    fontWeight:800,
                    textAlign:'center',
                    marginTop:70
                }}
                >{this.languageIndexer(
                    "Ponemos en tus manos las herramientas para definir tu norte.",
                    "We'll provide you the tools to shape your future."
                    )}</div> 
            );
        }
        else{
            return(
                <div
                style={{
                    color:"#024a99",
                    fontSize:'150%',
                    fontFamily:'Roboto',
                    fontWeight:800,
                    textAlign:'left',
                    marginTop:70,
                    width:'85%',
                    marginLeft:'auto',
                    marginRight:'auto'
                    }}
                >{this.languageIndexer(
                    "Ponemos en tus manos las herramientas para definir tu norte.",
                    "We'll provide you the tools to shape your future."
                    )}</div> 
            );
        }
    }

    showHideFisrtContent(){
        if(this.state.isVisible1===true){
            return(
                <div className='offersImage'>
                    <div className='whatCanDoText'>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',marginBottom:30}}>
                            <div style={{
                                display:'flex',
                                alignItems:'flex-end',
                                width:260
                            }}>
                                <img src={chartblue} style={{height:35,width:35}} alt='iconsShowcase'/>
                                <div style={{marginBottom:-6,marginLeft:5,fontSize:18,color:'rgba(0,0,0,1)'}}>
                                    Estad&iacute;sticas avanzadas
                                </div>
                            </div>
                            <div style={{fontSize:13,width:220,color:'rgba(0,0,0,.6)',paddingTop:10,lineHeight:'180%'}}>
                                Identifica oportunidades &oacute;ptimas para comprar o vender propiedades.
                            </div>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end'}}>
                            <div style={{
                                display:'flex',
                                alignItems:'flex-end',
                                width:260
                            }}>
                                <img src={complete} style={{height:35,width:35}} alt='iconsShowcase'/>
                                <div style={{marginBottom:-6,marginLeft:5,fontSize:18,color:'rgba(0,0,0,1)'}}>
                                    Datos Abundates
                                </div>
                            </div>
                            <div style={{fontSize:13,width:220,color:'rgba(0,0,0,.6)',paddingTop:10,lineHeight:'180%'}}>
                                La base de datos de comparables mas completa.
                            </div>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end'}}>
                            <div style={{
                                display:'flex',
                                alignItems:'flex-end',
                                width:260
                            }}>
                                <img src={update} style={{height:35,width:35}} alt='iconsShowcase'/>
                                <div style={{marginBottom:-6,marginLeft:5,fontSize:18,color:'rgba(0,0,0,1)'}}>
                                    Actualizaci&oacute;n Cont&iacute;nua
                                </div>
                            </div>
                            <div style={{fontSize:13,width:220,color:'rgba(0,0,0,.6)',paddingTop:10,lineHeight:'180%'}}>
                                Refrescamos los datos con frecuencia para mantenerte al d&iacute;a.
                            </div>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end'}}>
                            <div style={{
                                display:'flex',
                                alignItems:'flex-end',
                                width:260
                            }}>
                                <img src={exclamation} style={{height:35,width:35}} alt='iconsShowcase'/>
                                <div style={{marginBottom:-6,marginLeft:5,fontSize:18,color:'rgba(0,0,0,1)'}}>
                                    Detecta Eventos
                                </div>
                            </div>
                            <div style={{fontSize:13,width:220,color:'rgba(0,0,0,.6)',paddingTop:10,lineHeight:'180%'}}>
                                Como propiedades reposeidas, antes que sean enlistadas por entes bancarios.
                            </div>
                        </div>
                    </div>
                    <div className='whatCanDoImageContainer'>
                        <img className='whatCanDoImage' src={selectedAreas} alt='selectedAreas' loading='lazy' decoding='async' width={844} height={992} />
                    </div>
                </div>
            );
        }
    }

    showFirstContent(){
        if(this.state.showFirstContent===true){
            return( 
                    <div 
                    className='firstContentContainer'>
                        <div className='offerText'>
                            {this.ponemosIndexer()}
                            <div className='accedeText'>
                            {this.languageIndexer(
                                "Accede a información sobre ventas de propiedades en todo Puerto Rico y sigue de cerca los cambios del mercado en tus áreas de interés.",
                                "Access information on property sales throughout Puerto Rico and closely follow market changes in your areas of interest."
                                )}
                            </div>
                        </div>
                        {this.showHideFisrtContent()}
                    </div>
            );
        }
    }

    scatterStyleIndexer(){
        if(window.innerWidth>=2019){
            this.setState({
                scatterContainer:'scatterContainer scatterContainerLargest',
                scatterStyle:'scatterStyle scatterStyleLargest',
                secondContentContainer:'secondContentContainer secondContentContainerLargest'
            })
        }
        else if(window.innerWidth<2019&&window.innerWidth>=895){
            this.setState({
                scatterContainer:'scatterContainer',
                scatterStyle:'scatterStyle',
                secondContentContainer:'secondContentContainer'
            })
        }
        else if(window.innerWidth<895&&window.innerWidth>=580){
            this.setState({
                scatterContainer:'scatterContainer scatterContainerMid',
                scatterStyle:'scatterStyle scatterStyleMid',
                secondContentContainer:'secondContentContainer secondContentContainerMid'
            })
        }
        else if(window.innerWidth<580&&window.innerWidth>=421){
            this.setState({
                scatterContainer:'scatterContainer scatterContainerSmall',
                scatterStyle:'scatterStyle scatterStyleSmall',
                secondContentContainer:'secondContentContainer secondContentContainerSmall'
            })
        }
        else{
            this.setState({
                scatterContainer:'scatterContainer scatterContainerSmallest',
                scatterStyle:'scatterStyle scatterStyleSmallest',
                secondContentContainer:'secondContentContainer secondContentContainerSmallest'
            })
        }
    }

    customerIndexer(){
        if(this.state.customerIndex==='buyer'){
            return(
                <div className='showcaseContainer' key={buyerImage}>
                    <div className='showCaseArrows'>
                        <div className='Arrow1' onClick={()=>this.setState({lowerButtonClass1:'showcaseButton',lowerButtonClass2:'showcaseButton',lowerButtonClass3:'showcaseButton showcaseButtonActive',customerIndex:'appraiser'})}>
                            <div className='arrowStick1'></div>
                            <div className='arrowStick2'></div>
                        </div>
                        <div className='Arrow2'onClick={()=>this.setState({lowerButtonClass1:'showcaseButton',lowerButtonClass2:'showcaseButton showcaseButtonActive',lowerButtonClass3:'showcaseButton',customerIndex:'seller'})}>
                            <div className='arrowStick3'></div>
                            <div className='arrowStick4'></div>
                        </div>
                    </div>
                    <img src={buyerImage} alt='buyerImage' style={{marginLeft:10,height:200,width:'auto'}} loading='lazy' decoding='async' width={200} height={200} />
                    <div 
                        className='blueSmaller'
                        style={{
                            color:"#024a99",
                            fontSize:'180%',
                            fontFamily:'Roboto',
                            fontWeight:700,
                            paddingTop:70
                        }}
                        >
                        Has tu mejor oferta de manera informada
                        </div>
                    <div className='subTextBullets'>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginBottom:10,marginTop:10,marginLeft:40}}>
                            <div style={{fontWeight:700,fontSize:17,color:'rgba(0,0,0,.7)',textAlign:'left'}}>•Asegura el precio justo en tu compra</div> 
                            <div style={{marginLeft:20,fontsize:16,fontWeight:700,color:'rgba(0,0,0,.7)',textAlign:'left'}}>Evalúa el valor ideal antes de adquirir y evita pagar de más por tu propiedad.</div>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginBottom:9,marginLeft:40}}>
                            <div style={{fontWeight:700,fontSize:17,color:'rgba(0,0,0,.7)',textAlign:'left',width:'100%'}}>•Analiza el mercado a tu favor</div> 
                            <div style={{marginLeft:20,fontsize:16,fontWeight:700,color:'rgba(0,0,0,.7)',textAlign:'left'}}>Descubre si los valores en tu zona de interés están subiendo o bajando para realizar una inversión estratégica.</div>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginBottom:9,marginLeft:40}}>
                            <div style={{fontWeight:700,fontSize:17,color:'rgba(0,0,0,.7)',textAlign:'left',width:'100%'}}>•Sé el primero en aprovechar oportunidades únicas</div> 
                            <div style={{marginLeft:20,fontsize:16,fontWeight:700,color:'rgba(0,0,0,.7)',textAlign:'left'}}>Identifica propiedades reposeídas antes de que aparezcan en los listados bancarios y adelántate a otros compradores.</div>
                        </div>
                    </div>
                </div>
            );
        }
        else if(this.state.customerIndex==='seller'){
            return(
                <div className='showcaseContainer showcaseContainerLonger' key={sellerImage}>
                    <div className='showCaseArrows'>
                        <div className='Arrow1' onClick={()=>this.setState({lowerButtonClass1:'showcaseButton showcaseButtonActive',lowerButtonClass2:'showcaseButton',lowerButtonClass3:'showcaseButton',customerIndex:'buyer'})}>
                            <div className='arrowStick1'></div>
                            <div className='arrowStick2'></div>
                        </div>
                        <div className='Arrow2' onClick={()=>this.setState({lowerButtonClass1:'showcaseButton',lowerButtonClass2:'showcaseButton',lowerButtonClass3:'showcaseButton showcaseButtonActive',customerIndex:'appraiser'})}>
                            <div className='arrowStick3'></div>
                            <div className='arrowStick4'></div>
                        </div>
                    </div>
                    <img src={sellerImage} alt='buyerImage' style={{height:200,width:'auto'}} loading='lazy' decoding='async' width={200} height={200} />
                    <div 
                        className='blueSmaller'
                        style={{
                            color:"#024a99",
                            fontSize:'180%',
                            fontFamily:'Roboto',
                            fontWeight:700,
                            paddingTop:70
                        }}
                        >
                        Aumenta la efectividad de tus ventas
                        </div>
                    <div className='subTextBullets'>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginBottom:10,marginTop:10,marginLeft:40}}>
                            <div style={{fontWeight:700,fontSize:17,color:'rgba(0,0,0,.7)',textAlign:'left'}}>•Maximiza tus cierres con precios optimizados</div> 
                            <div style={{marginLeft:20,fontsize:16,fontWeight:700,color:'rgba(0,0,0,.7)',textAlign:'left'}}>Ajusta los precios de tus propiedades de manera estratégica para alcanzar el equilibrio perfecto entre ganancia y rapidez de cierre.</div>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginBottom:9,marginLeft:40}}>
                            <div style={{fontWeight:700,fontSize:17,color:'rgba(0,0,0,.7)',textAlign:'left',width:'100%'}}>•Ofrece seguridad y confianza a tus clientes</div> 
                            <div style={{marginLeft:20,fontsize:16,fontWeight:700,color:'rgba(0,0,0,.7)',textAlign:'left'}}>Ofrece información precisa y detallada que les permita tomar decisiones de inversión con total tranquilidad.</div>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginBottom:9,marginLeft:40}}>
                            <div style={{fontWeight:700,fontSize:17,color:'rgba(0,0,0,.7)',textAlign:'left',width:'100%'}}>•Mantente siempre un paso adelante en el mercado</div> 
                            <div style={{marginLeft:20,fontsize:16,fontWeight:700,color:'rgba(0,0,0,.7)',textAlign:'left'}}>Accede a los datos más recientes de ventas en múltiples áreas para ofrecer las mejores recomendaciones basadas en las últimas tendencias.</div>
                        </div>
                    </div>
                </div>
            );
        }
        else if(this.state.customerIndex==='appraiser'){
            return(
                <div className='showcaseContainer showcaseContainerLonger' key={appraise}>
                    <div className='showCaseArrows'>
                        <div className='Arrow1'onClick={()=>this.setState({lowerButtonClass1:'showcaseButton',lowerButtonClass2:'showcaseButton showcaseButtonActive',lowerButtonClass3:'showcaseButton',customerIndex:'seller'})}>
                            <div className='arrowStick1'></div>
                            <div className='arrowStick2'></div>
                        </div>
                        <div className='Arrow2' onClick={()=>this.setState({lowerButtonClass1:'showcaseButton showcaseButtonActive',lowerButtonClass2:'showcaseButton',lowerButtonClass3:'showcaseButton',customerIndex:'buyer'})}>
                            <div className='arrowStick3'></div>
                            <div className='arrowStick4'></div>
                        </div>
                    </div>
                    <img src={appraise} alt='buyerImage' style={{height:200,width:'auto'}} loading='lazy' decoding='async' width={200} height={200} />
                    <div 
                        className='blueSmaller'
                        style={{
                            color:"#024a99",
                            fontSize:'180%',
                            fontFamily:'Roboto',
                            fontWeight:700,
                            textAlign:'center',
                            paddingTop:70
                        }}
                        >
                        Estima el valor de una propiedad de manera precisa y r&aacute;pida
                        </div>
                    <div className='subTextBullets'>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginBottom:10,marginTop:10,marginLeft:40}}>
                            <div style={{fontWeight:700,fontSize:17,color:'rgba(0,0,0,.7)',textAlign:'left'}}>•Enfócate en las áreas que realmente importan</div> 
                            <div style={{marginLeft:20,fontsize:16,fontWeight:700,color:'rgba(0,0,0,.7)',textAlign:'left'}}>Selecciona y compara específicamente las zonas que te interesan para evitar datos irrelevantes.</div>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginBottom:9,marginLeft:40}}>
                            <div style={{fontWeight:700,fontSize:17,color:'rgba(0,0,0,.7)',textAlign:'left',width:'100%'}}>•Aprovecha nuestra vasta fuente de información</div> 
                            <div style={{marginLeft:20,fontsize:16,fontWeight:700,color:'rgba(0,0,0,.7)',textAlign:'left'}}>La enorme cantidad de datos respaldará tus decisiones, y nuestras herramientas te ayudarán a afinar cada detalle.</div>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',marginBottom:9,marginLeft:40}}>
                            <div style={{fontWeight:700,fontSize:17,color:'rgba(0,0,0,.7)',textAlign:'left',width:'100%'}}>•Simplifica tus análisis con herramientas intuitivas</div> 
                            <div style={{marginLeft:20,fontsize:16,fontWeight:700,color:'rgba(0,0,0,.7)',textAlign:'left'}}>Filtra por precios, fechas, tamaños de estructuras y exporta la información a Excel para un análisis más profundo.</div>
                        </div>
                    </div>
                </div>
            );
        }
    }

    showScatter(){
        if(this.state.isVisible2){
            return(
                <img src={scatterPlot} className={`${this.state.scatterStyle}`} alt='scatterPlot' loading='lazy' decoding='async' width={1795} height={205} />
            );
        }
    }

    showSecondContent(){
        if(this.state.showSecondContent===true){
            return( 
                    <div className={this.state.secondContentContainer}>
                            <div className={this.state.scatterContainer} style={{display:'flex'}}>
                                {this.showScatter()}  
                            </div>
                        <div className='offerText2'>
                             <div 
                             style={{
                                color:"#024a99",
                                fontSize:'180%',
                                fontFamily:'Roboto',
                                fontWeight:800,
                                textAlign:'center',
                                paddingTop:70
                            }}
                             >
                                {this.languageIndexer(
                                        "Tu éxito en bienes raíces está a un click",
                                        "The most advanced property analysis resource."
                                        )}
                             </div>
                             <div className='accedeTextOther'>
                                {this.languageIndexer(
                                        "Hemos apoyado multiples profesionales a optimizar sus resultados con datos precisos y confiables.",
                                        "Evaluate whether a property is appropriately priced before selling or buying. Analyze investments and save potential thousands on your next transaction."
                                        )}
                             </div>
                             <img src={success} alt='success' className='successIcon' loading='lazy' decoding='async' width={48} height={48} />
                        </div>
                    <div className='showcaseButtons'>
                        <div className='showcaseButtonOuter'>
                            <div className='showcaseButtonContainer'>
                                <div onClick={()=>this.setState({lowerButtonClass1:'showcaseButton showcaseButtonActive',lowerButtonClass2:'showcaseButton',lowerButtonClass3:'showcaseButton',customerIndex:'buyer'})} className={this.state.lowerButtonClass1}>
                                    <img src={buyer} style={{height:50,width:50,marginTop:15}} alt='lowerButtonClass1' loading='lazy' decoding='async' width={96} height={96} />
                                    <div className='buttonTextBottom'>Compradores</div>
                                </div>
                                <div onClick={()=>this.setState({lowerButtonClass1:'showcaseButton',lowerButtonClass2:'showcaseButton showcaseButtonActive',lowerButtonClass3:'showcaseButton',customerIndex:'seller'})} className={this.state.lowerButtonClass2}>
                                    <img src={sellers} style={{height:50,width:50,marginTop:15}} alt='lowerButtonClass2' loading='lazy' decoding='async' width={96} height={96} />
                                    <div className='buttonTextBottom'>Vendedores</div>
                                </div>
                                <div onClick={()=>this.setState({lowerButtonClass1:'showcaseButton',lowerButtonClass2:'showcaseButton',lowerButtonClass3:'showcaseButton showcaseButtonActive',customerIndex:'appraiser'})} className={this.state.lowerButtonClass3}>
                                    <img src={sketch} style={{height:40,width:40,marginTop:25,marginRight:-8,marginBottom:0}} alt='lowerButtonClass3' loading='lazy' decoding='async' width={64} height={64} />
                                    <div className='buttonTextBottom'>Tasadores</div>
                                </div>
                            </div>
                            {this.customerIndexer()}
                        </div>
                        <div className='imagesGallery'>
                            {this.languageVideoIndexer()}
                        </div>
                        <button onClick={()=>{
                            this.setState({contentIndex:'prices'})
                            sendAnalytics("PRICES", "Routed to prices by ver ofertas", String(new Date()));
                            trackEvent('view_pricing', { source: 'hero_ver_ofertas' });
                            }} className="ver-ofertas-button">
                            Ver Ofertas
                        </button>
                    </div>
                    <div 
                    style={{
                            fontSize:14,
                            fontWeight:700,
                            color:'rgba(0,0,0,.6)',
                            marginBottom:120,
                            bottom:0
                        }}>
                        <div className='bottomNav'>
                            <div onClick={()=>this.props.termsWindowShow()}>Terminos de Uso</div>
                            <div onClick={()=>this.props.policyWindowShow()}>Politica de Privacidad</div>
                            {/* <div onClick={()=>this.setState({contentIndexer:'contact'})}>Contactanos</div> */}
                        </div>
                        <div style={{color:'rgba(0,0,0,.8'}}>Copyright (c) CASADATA LLC 2026. All Rights Reserved.</div>
                    </div>
                </div>
            );
        }
    }

    textSwitcher(){
            if(window.innerWidth>=1905){
                return(
                    <div className='imgContainerOuter'>
                        <div className="image-container">
                            <img src={spreadmid} alt="Casadata dashboard view" loading='eager' decoding='async' fetchpriority='high' srcSet={`${spreadsmall} 1532w, ${spreadmid} 2486w`} sizes='(max-width: 1263px) 100vw, 100vw' width={2486} height={1840} />
                            <div className="image-overlay">
                                <div className='somos'>
                                    <div style={{
                                        fontWeight:100,
                                        borderBottom:'5px solid rgba(255,255,255,.3)',
                                        marginBottom:10
                                        }}>Somos CASADATA</div>
                                    <div className='somosBullet'>An&aacute;lisis.</div>
                                    <div className='somosBullet'>Comparables.</div>
                                    <div className='somosBullet'>Proyecciones.</div>
                                    <div className='somosBullet'>Estimados.</div>
                                    <div className='finalBullet'>
                                        <div>De propiedades en todo Puerto Rico</div>
                                        <img style={{
                                            height:50,
                                            width:'auto',
                                            position:'relative',
                                            marginLeft:10,
                                            opacity:0.7
                                        }} src={prmap} alt='prmap' loading='lazy' decoding='async' width={515} height={229} />
                                    </div>
                                    <div 
                                        // onClick={()=>this.mainContainer.scrollTo({
                                        // top: 940, // Change this to your desired vertical scroll position
                                        // left: 0,   // Change this to your desired horizontal scroll position, if needed
                                        // behavior: 'smooth'
                                        // })} 
                                        onClick={()=>{
                                            const el = this.mainContainer || document.getElementById("mainContainer");
                                            if (el) el.scrollTo({ top: 940, left: 0, behavior: 'smooth' });
                                        }}
                                        
                                        className='masDetalles'>Mas Detalles</div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
            else if(window.innerWidth<1905&&window.innerWidth>=1264){
                return(
                    <div className='imgContainerOuter'>
                        <div className="image-container">
                            <img src={spreadmid} alt="Casadata dashboard view" loading='eager' decoding='async' fetchpriority='high' srcSet={`${spreadsmall} 1532w, ${spreadmid} 2486w`} sizes='(max-width: 1263px) 100vw, 100vw' width={2486} height={1840} />
                            <div className="image-overlay">
                                <div className='somos'>
                                    <div style={{
                                        fontWeight:100,
                                        borderBottom:'5px solid rgba(255,255,255,.3)',
                                        marginBottom:10
                                        }}>Somos CASADATA</div>
                                    <div className='somosBullet'>An&aacute;lisis.</div>
                                    <div className='somosBullet'>Comparables.</div>
                                    <div className='somosBullet'>Proyecciones.</div>
                                    <div className='somosBullet'>Estimados.</div>
                                    <div className='finalBullet'>
                                        <div>De propiedades en todo Puerto Rico</div>
                                        <img style={{
                                            height:50,
                                            width:'auto',
                                            position:'relative',
                                            marginLeft:10,
                                            opacity:0.7
                                        }} src={prmap} alt='prmap' loading='lazy' decoding='async' width={515} height={229} />
                                    </div>
                                    <div
                                    // onClick={()=>this.mainContainer.scrollTo({
                                    //     top: 880, // Change this to your desired vertical scroll position
                                    //     left: 0,   // Change this to your desired horizontal scroll position, if needed
                                    //     behavior: 'smooth'
                                    //     })}
                                    onClick={()=>{
                                        const el = this.mainContainer || document.getElementById("mainContainer");
                                        if (el) el.scrollTo({ top: 880, left: 0, behavior: 'smooth' });
                                    }}
                                     className='masDetalles2'>Mas Detalles</div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
            else{
                return(
                    <div className='imgContainerOuter'>
                        <div className="image-containerAlt">
                            <img src={spreadsmallMobile960} alt="Casadata dashboard view" loading='eager' decoding='async' fetchpriority='high' srcSet={`${spreadsmallMobile480} 480w, ${spreadsmallMobile960} 960w`} sizes='100vw' width={960} height={1144} />
                            <div className="image-overlayAlt">
                                <div className='somos2'>Somos</div>
                                <div style={{
                                    borderBottom:'4px solid rgba(255,255,255,.5)'
                                }} className='somos2'>CASADATA</div>
                                <div style={{marginRight:'5%'}} className='somosBullet'>An&aacute;lisis.</div>
                                <div style={{marginRight:'5%'}} className='somosBullet'>Comparables.</div>
                                <div style={{marginRight:'5%'}} className='somosBullet'>Proyecciones.</div>
                                <div style={{marginRight:'5%'}} className='somosBullet'>Estimados.</div>
                                <div className='finalBullet2'>
                                        <div style={{
                                            fontSize:16
                                        }}>De propiedades en todo Puerto Rico</div>
                                        <img style={{
                                            height:50,
                                            width:'auto',
                                            position:'relative',
                                            marginLeft:10,
                                            opacity:0.7
                                        }} src={prmap} alt='prmap' loading='lazy' decoding='async' width={515} height={229} />
                                </div>
                                <div
                                // onClick={()=>this.mainContainer.scrollTo({
                                //     top: 900, // Change this to your desired vertical scroll position
                                //     left: 0,   // Change this to your desired horizontal scroll position, if needed
                                //     behavior: 'smooth'
                                //     })}
                                onClick={()=>{
                                    const el = this.mainContainer || document.getElementById("mainContainer");
                                    if (el) el.scrollTo({ top: 900, left: 0, behavior: 'smooth' });
                                }}
                                className='masDetalles2'>Mas Detalles</div>
                            </div>
                        </div>
                    </div>
                );
            }
    }

    languageIndexer(spanishMessage,englishMessage){
        if(this.props.selectedLanguage==='spanish'){
            return(spanishMessage);
        }
        else if(this.props.selectedLanguage==='english'){return(englishMessage);}
    }

    getHeroFreshnessLabel(){
        const freshness = this.state.heroFreshness || {};
        const label = this.props.selectedLanguage === 'english' ? freshness.label_en : freshness.label_es;
        const fallbackLabel = this.getCurrentMonthYearLabel(this.props.selectedLanguage === 'english' ? 'english' : 'spanish');
        return label || fallbackLabel || this.languageIndexer('Verificando...', 'Checking...');
    }

    getHeroFreshnessTagText(){
        const freshness = this.state.heroFreshness || {};
        const label = this.props.selectedLanguage === 'english' ? freshness.label_en : freshness.label_es;
        const fallbackLabel = this.getCurrentMonthYearLabel(this.props.selectedLanguage === 'english' ? 'english' : 'spanish');
        const effectiveLabel = label || fallbackLabel;
        if (effectiveLabel) {
            return this.languageIndexer(`Actualizado a ${effectiveLabel}`, `Updated through ${effectiveLabel}`);
        }
        return this.languageIndexer('Verificando actualizacion', 'Checking update status');
    }

    languageVideoIndexer(spanishMessage,englishMessage){
        if(this.props.selectedLanguage==='spanish'){
            return(
                <div className='embed-container'>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/gQ0DU7Kvjak?si=JIJa56XU6oi5ztDo" title="YouTube video player" loading="lazy" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div>
            );
        }
        else if(this.props.selectedLanguage==='english'){
            return(
                <div className='embed-container'>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/gQ0DU7Kvjak?si=JIJa56XU6oi5ztDo" title="YouTube video player" loading="lazy" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div>
            );
        }
    }

    handleStateChange = (state) => {
        this.setState({ menuOpen: state.isOpen });
    };

    // Function to close the menu and update the selected state
    // On an SEO route (e.g. /es/estadisticas-*), "Inicio" and the brand logo
    // must actually navigate back to the landing document; updating component
    // state alone leaves the URL — and therefore the topic page — in place.
    navigateHomeIfSeoRoute = () => {
        if (typeof window === 'undefined') return false;
        const path = String(window.location.pathname || '/');
        if (path !== '/' && this.getSeoTopicPage()) {
            window.location.assign('/');
            return true;
        }
        return false;
    };

    closeMenu = (selection) => {
        trackEvent('frontpage_menu_click', {
            destination: selection,
            menu_type: 'burger'
        });
        if(selection!=='login'&&selection!=='signup'){
            this.sendLandingAnalytics('NAV_CLICK', {
                src: 'burger_menu',
                to: selection,
                from: this.state.contentIndex
            });
            this.setState({
                menuOpen: false,
                contentIndex: selection, // Update selected state with the clicked link
            });
        }
        else if(selection==='login'){
            this.trackAuthIntent('login', 'burger_menu');
            this.props.loginWindow();
            this.setState({
                menuOpen: false
            });
        }
        else{
            this.trackAuthIntent('signup', 'burger_menu');
            this.props.signupWindow();
            this.setState({
                menuOpen: false
            });
        }
    };

    trackAuthIntent = (target = 'signup', source = 'frontpage') => {
        this.sendLandingAnalytics('AUTH_CLICK', {
            target,
            src: source,
            route: this.state.contentIndex,
            sec: this.landingLastSection
        });
    };

    handleLanguageSelection = (language, source = 'language_toggle') => {
        const current = this.props.selectedLanguage === 'english' ? 'english' : 'spanish';
        const next = language === 'english' ? 'english' : 'spanish';

        if (current !== next) {
            this.sendLandingAnalytics('LANG_SWITCH', {
                from: current === 'english' ? 'en' : 'es',
                to: next === 'english' ? 'en' : 'es',
                src: source,
                route: this.state.contentIndex
            });
            trackEvent('language_switch', { from: current, to: next, source });
        }

        if (next === 'english') {
            this.props.englishSelected && this.props.englishSelected();
            return;
        }
        this.props.spanishSelected && this.props.spanishSelected();
    };


    routeToPricing = (source = 'frontpage_cta') => {
        this.sendLandingAnalytics('CTA_CLICK', {
            cta: 'pricing',
            src: source,
            from: this.state.contentIndex,
            to: 'prices'
        });
        this.setState({ contentIndex: 'prices' });
        sendAnalytics("PRICES", `Routed to prices from ${source}`, String(new Date()));
        trackEvent('view_pricing', { source });
    };

    routeToContact = (source = 'frontpage_cta') => {
        this.sendLandingAnalytics('CTA_CLICK', {
            cta: 'contact',
            src: source,
            from: this.state.contentIndex,
            to: 'contact'
        });
        this.setState({ contentIndex: 'contact' });
        sendAnalytics("CONTACT", `Routed to contact from ${source}`, String(new Date()));
        trackEvent('view_contact_route', { source });
    };

    openTrialAccess = (source = 'frontpage_trial_cta', options = {}) => {
        const baseUrl = String(this.state.serverIp || 'https://casadata.io').replace(/\/+$/, '');
        const trialParams = new URLSearchParams();
        trialParams.set('source', String(options.backendSource || 'nfc'));
        trialParams.set('source_id', String(options.sourceId || 'card_dev_01'));
        const rid = String(options.rid || '').trim();
        const customerFingerprint = String(options.customerFingerprint || '').trim();
        if (rid) {
            trialParams.set('rid', rid);
        }
        if (customerFingerprint) {
            trialParams.set('customerFingerprint', customerFingerprint);
        }
        const trialUrl = `${baseUrl}/api/trialAccess?${trialParams.toString()}`;
        this.sendLandingAnalytics('CTA_CLICK', {
            cta: 'trial_access',
            src: source,
            from: this.state.contentIndex
        });
        sendAnalytics("TRIAL", `Trial access click from ${source}`, String(new Date()));
        trackEvent('frontpage_trial_click', { source });
        this.captureLandingExit('to_trial_access');
        window.location.href = trialUrl;
    };

    renderPricingTrialOffer() {
        if (this.state.trialOfferVisibility === 'hidden') {
            return null;
        }

        const isLoading = this.state.trialOfferVisibility === 'loading';

        return (
            <div className={`cdTrialOfferCard${isLoading ? ' loading' : ''}`}>
                <div className='cdTrialOfferEyebrow'>
                    {this.languageIndexer('PRUEBA ANTES DE COMPRAR', 'TRY BEFORE YOU BUY')}
                </div>
                {isLoading ? (
                    <div className='cdTrialOfferStatus'>
                        {this.languageIndexer('Verificando disponibilidad de la prueba...', 'Checking trial availability...')}
                    </div>
                ) : (
                    <>
                        <button
                            type='button'
                            className='cdTrialOfferBtn'
                            onClick={() => this.openTrialAccess('pricing_trial_offer', {
                                backendSource: 'pricing_page',
                                sourceId: 'pricing_6h_offer',
                                rid: this.state.trialEligibilityRid,
                                customerFingerprint: this.state.trialEligibilityFingerprint
                            })}
                        >
                            {this.languageIndexer('PROBAR PLUSMAX 6H GRATIS', 'TRY PLUSMAX FREE FOR 6H')}
                        </button>
                        <div className='cdTrialOfferFootnote'>
                            {this.languageIndexer('Acceso completo. Sin tarjeta, sin registro.', 'Full access. No card, no sign-up.')}
                        </div>
                    </>
                )}
            </div>
        );
    }

    scrollToLandingSection = (targetId, source = 'frontpage_cta') => {
        const target = document.getElementById(targetId);
        this.sendLandingAnalytics('CTA_SCROLL', {
            src: source,
            to: targetId,
            found: target ? '1' : '0',
            sec: this.landingLastSection
        });
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        trackEvent('frontpage_scroll_section', { source, target: targetId });
    };

    playDemoVideo = (source = 'frontpage_demo') => {
        this.sendLandingAnalytics('DEMO_PLAY', {
            src: source,
            sec: this.landingLastSection
        });
        if (!this.state.showDemoVideo) {
            this.setState({ showDemoVideo: true });
        }
        trackEvent('frontpage_demo_play', { source });
    };

    renderLanguageToggle(compact = false) {
        const selected = this.props.selectedLanguage === 'english' ? 'english' : 'spanish';
        const classes = compact ? 'cdLangSwitch compact' : 'cdLangSwitch';

        return (
            <div className={classes} role='group' aria-label={this.languageIndexer('Selector de idioma', 'Language selector')}>
                <button
                    type='button'
                    className={selected === 'spanish' ? 'active' : ''}
                    onClick={() => this.handleLanguageSelection('spanish', compact ? 'compact_toggle' : 'desktop_toggle')}
                    aria-pressed={selected === 'spanish'}
                >
                    ES
                </button>
                <button
                    type='button'
                    className={selected === 'english' ? 'active' : ''}
                    onClick={() => this.handleLanguageSelection('english', compact ? 'compact_toggle' : 'desktop_toggle')}
                    aria-pressed={selected === 'english'}
                >
                    EN
                </button>
            </div>
        );
    }


    navBarIndexer(){
        const landingCopy = this.getLandingCopy();
        if(window.innerWidth<=1087){
            return(
                <>
                    <Menu 
                        isOpen={this.state.menuOpen}
                        onStateChange={this.handleStateChange}
                    >
                        <div className='burgerElement' onClick={() => {
                            if (this.navigateHomeIfSeoRoute()) return;
                            this.closeMenu('main');
                        }}>
                            {this.languageIndexer('Inicio', 'Home')}
                        </div>
                        <div className='burgerElement' onClick={() =>{
                            this.routeToPricing('burger_menu');
                            this.setState({ menuOpen: false });
                        }}>
                            {this.languageIndexer('Precios', 'Pricing')}
                        </div>
                        <a
                            className='burgerElement'
                            href='/es/estadisticas-puerto-rico'
                            style={{ textDecoration: 'none' }}
                            onClick={() => trackEvent('stats_nav_click', { source: 'burger_menu' })}
                        >
                            {this.languageIndexer('Estadísticas', 'Statistics')}
                        </a>
                        <div className='burgerElement' onClick={() => {
                            this.closeMenu('login');
                            sendAnalytics("LOGIN", 'Routed to login from burger', String(new Date()));
                        }}>
                            {this.languageIndexer('Login', 'Login')}
                        </div>
                        <div className='burgerElement' onClick={() => {
                            this.closeMenu('signup');
                            sendAnalytics("SIGNUP", 'Routed to signup from burger', String(new Date()));
                        }}>
                            {this.languageIndexer('Registrate', 'Sign Up')}
                        </div>
                        <div className='burgerElement' onClick={() => {
                            this.routeToContact('burger_menu');
                            this.setState({ menuOpen: false });
                        }}>
                            {this.languageIndexer('Contactanos', 'Contact Us')}
                        </div>
                        <div className='burgerElement' onClick={() => {
                            this.handleLanguageSelection('spanish', 'burger_menu');
                            this.setState({ menuOpen: false });
                        }}>
                            Espanol
                        </div>
                        <div className='burgerElement' onClick={() => {
                            this.handleLanguageSelection('english', 'burger_menu');
                            this.setState({ menuOpen: false });
                        }}>
                            English
                        </div>
                    </Menu>

                    <div className='navBar cdNavBarModern'>
                        <button type='button' className='cdNavBrand cdNavBrandCompact' onClick={()=>{
                            if (this.navigateHomeIfSeoRoute()) return;
                            this.setState({contentIndex:'main'});
                        }}>
                            <div className='logoContainer2Outer'>
                                <div className='logoContainer3'>
                                    <img className='navLogo' height={42} width={47} src={Logo} alt='Casadata Logo' />
                                    <div className='logoName'>CASADATA</div>
                                </div>
                            </div>
                        </button>

                        <div className='cdNavMobileActions'>
                            {this.renderLanguageToggle(true)}
                            <button
                                type='button'
                                className='cdNavPrimaryBtn cdNavMobilePrimaryBtn'
                                onClick={() => {
                                    this.trackAuthIntent('signup', 'mobile_navbar');
                                    this.props.signupWindow();
                                    sendAnalytics("SIGNUP", 'Routed to signup from mobile navbar', String(new Date()));
                                }}
                            >
                                {this.languageIndexer('Sign Up', 'Sign Up')}
                            </button>
                        </div>
                    </div>  
                </>
            );
        }

        return(
            <div className='navBar cdNavBarModern'>
                    <div className='navBtnsLesser'>
                        <div onClick={()=>{
                            if (this.navigateHomeIfSeoRoute()) return;
                            this.setState({contentIndex:'main'});
                            }} className='lesserBtns'>
                            <img src={houseicon} height='60px' width='60px' alt='houseicon' className='lesserIcons' loading='lazy' decoding='async' />
                            <div className='iconText'>{this.languageIndexer('Inicio', 'Home')}</div>
                        </div>
                        <div onClick={()=>{
                            this.routeToPricing('desktop_nav');
                            }} className='lesserBtns'>
                            <img src={pricing} height='50px'
                            style={{
                                marginTop:10,
                                transform:'translateY(-3px)'
                            }}
                            width='50px' alt='pricingicon' className='lesserIcons' loading='lazy' decoding='async' />
                            <div style={{marginTop:-6}} className='iconText'>{this.languageIndexer('Precios', 'Pricing')}</div>
                        </div>
                        <a
                            href='/es/estadisticas-puerto-rico'
                            className='lesserBtns'
                            style={{ textDecoration: 'none' }}
                            onClick={() => trackEvent('stats_nav_click', { source: 'desktop_nav' })}
                        >
                            <img src={chartblue} height='50px'
                            style={{
                                marginTop:10,
                                transform:'translateY(-3px)'
                            }}
                            width='50px' alt='estadisticasicon' className='lesserIcons' loading='lazy' decoding='async' />
                            <div style={{marginTop:-6}} className='iconText'>{this.languageIndexer('Estadísticas', 'Statistics')}</div>
                        </a>
                        <div onClick={()=>{
                            this.routeToContact('desktop_nav');
                            }} className='lesserBtns'>
                            <img src={aboutus} height='50px'
                            style={{
                                marginTop:10,
                                transform:'translateY(-3px)'
                            }}
                            width='50px' alt='contacticon' className='lesserIcons' loading='lazy' decoding='async' />
                            <div style={{marginTop:-6}} className='iconText'>{this.languageIndexer('Contacto', 'Contact')}</div>
                        </div>
                    </div>
                    <button type='button' className='cdNavBrand' onClick={()=>{
                        if (this.navigateHomeIfSeoRoute()) return;
                        this.setState({contentIndex:'main'});
                    }}>
                        <div className='logoContainer2Outer'>
                            <div className='logoContainer2'>
                                <img className='navLogo' height={42} width={47} src={Logo} alt='' />
                            </div>
                            <div className='logoText'>CASADATA</div>
                        </div>
                        <div className='underText'>{landingCopy.navTagline}</div>
                    </button>
                    <div className='navBarButtons cdNavActions'>
                    {this.renderLanguageToggle()}
                    <button
                        type='button'
                        onClick={() => {
                            this.trackAuthIntent('login', 'desktop_navbar');
                            this.props.loginWindow();
                            sendAnalytics("LOGIN", 'Routed to login from navbar', String(new Date()));
                        }}
                        className='cdNavGhostBtn'
                        >
                        {this.languageIndexer('Login','Login')}
                    </button>
                    <button
                        type='button'
                        onClick={() => {
                            this.trackAuthIntent('signup', 'desktop_navbar');
                            this.props.signupWindow();
                            sendAnalytics("SIGNUP", 'Routed to signup from navbar', String(new Date()));
                        }}
                        className='cdNavPrimaryBtn'
                        >
                        {this.languageIndexer('Sign Up','Sign Up')}
                    </button>
                    </div>
                </div>
        );
    }

    showSettings(event) {
        event.preventDefault();
        // You can handle any actions here for settings or other menu items
      }

    handleScrollMain = (scrollPosition) => {    
        if (scrollPosition > this.state.scrollThreshhold1 && (this.state.showSecondContent !== true || this.state.isVisible1 !== true)) {
            this.setState({ isVisible1: true, showSecondContent: true });
        } 
        if (scrollPosition > this.state.scrollThreshhold2 && this.state.isVisible2 !== true) {
            this.setState({ isVisible2: true });
        } 
    };

    sendContactData(e) {
        e.preventDefault();
        fetch(`${this.state.serverIp}/api/contact`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ 
                contactName: this.state.contactName,
                contactEmail: this.state.contactEmail,
                contactPhone: this.state.contactPhone,
                contactMessage: this.state.contactMessage
            }),
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            this.setState({contactSent:true})
            track('Lead', {
                content_name: 'contact_form',
                content_category: 'frontpage_contact'
            });
            track('Contact', {
                content_name: 'contact_form'
            });
            trackEvent('generate_lead', {
                lead_type: 'contact_form',
                source: 'frontpage_contact'
            });
            sendAnalytics("CONTACT", "Contact form submitted", String(new Date()));
        })
        .catch((error) => {
            console.error('Error:', error);
            trackEvent('contact_form_failed', { source: 'frontpage_contact' });
        });
    }

    contactSent(){
        // Shared footer (same vibe as Prices route)
        const footer = (
            <div style={{ fontSize: 14, color: 'rgba(0,0,0,.6)', fontWeight: 700, marginTop: 18 }}>
                <div className='bottomNav'>
                    <div onClick={()=>this.props.termsWindowShow()}>Terminos de Uso</div>
                    <div onClick={()=>this.props.policyWindowShow()}>Politica de Privacidad</div>
                </div>
                <div style={{ color: 'rgba(0,0,0,.8)' }}>
                    Copyright (c) CASADATA LLC 2026. All Rights Reserved.
                </div>
            </div>
        );
    
        if(this.state.contactSent === false){
            return(
                <section className="cdContactRoute">
                    <div className="cdContactWrap">
                        <div className="cdContactCard">
                            <div className="cdContactHeader">
                                <div className="cdContactTitle">
                                    {this.languageIndexer("Contactanos", "Contact Us")}
                                </div>
                                <div className="cdContactSubtitle">
                                    {this.languageIndexer(
                                        "Cuentanos como podemos ayudarte. Respuesta estimada en 24 horas laborables.",
                                        "Tell us how we can help. Typical response time: within 24 business hours."
                                    )}
                                </div>
                            </div>
                            <div className="cdContactChannels">
                                <div>{this.languageIndexer("Email directo: information@casadata.io", "Direct email: information@casadata.io")}</div>
                                <div>{this.languageIndexer("Horario: lunes a viernes", "Hours: Monday to Friday")}</div>
                            </div>
    
                            <form className="cdContactForm" onSubmit={(e)=>this.sendContactData(e)}>
                                <div className="cdFieldGrid">
                                    <div className="cdField">
                                        <label className="cdLabel" htmlFor="cd_name">
                                            {this.languageIndexer("Nombre Completo", "Full Name")}
                                        </label>
                                        <input
                                            className="cdInput"
                                            onChange={(e)=>this.setState({contactName:e.target.value})}
                                            type="text"
                                            id="cd_name"
                                            name="name"
                                            placeholder={this.languageIndexer("Ej. Juan Perez", "e.g., John Smith")}
                                            required
                                        />
                                    </div>
    
                                    <div className="cdField">
                                        <label className="cdLabel" htmlFor="cd_email">
                                            {this.languageIndexer("Correo Electronico", "Email")}
                                        </label>
                                        <input
                                            className="cdInput"
                                            onChange={(e)=>this.setState({contactEmail:e.target.value})}
                                            type="email"
                                            id="cd_email"
                                            name="email"
                                            placeholder={this.languageIndexer("Ej. correo@dominio.com", "e.g., name@domain.com")}
                                            required
                                        />
                                    </div>
    
                                    <div className="cdField">
                                        <label className="cdLabel" htmlFor="cd_phone">
                                            {this.languageIndexer("Numero de Telefono", "Phone")}
                                        </label>
                                        <input
                                            className="cdInput"
                                            onChange={(e)=>this.setState({contactPhone:e.target.value})}
                                            type="tel"
                                            id="cd_phone"
                                            name="phone"
                                            placeholder={this.languageIndexer("Opcional", "Optional")}
                                        />
                                    </div>
                                </div>
    
                                <div className="cdField">
                                    <label className="cdLabel" htmlFor="cd_message">
                                        {this.languageIndexer("Mensaje", "Message")}
                                    </label>
                                    <textarea
                                        className="cdTextarea"
                                        onChange={(e)=>this.setState({contactMessage:e.target.value})}
                                        id="cd_message"
                                        name="message"
                                        rows="5"
                                        placeholder={this.languageIndexer("Como podemos servirle?", "How can we help?")}
                                        required
                                    />
                                </div>
    
                                <button type="submit" className="cdPrimaryBtn">
                                    {this.languageIndexer("Enviar Mensaje", "Send Message")}
                                </button>
    
                                <div className="cdContactNote">
                                    {this.languageIndexer(
                                        "Usaremos tus datos solo para responder tu solicitud. Consulta nuestra Politica de Privacidad.",
                                        "We use your data only to respond to your request. See our Privacy Policy."
                                    )}
                                </div>
                            </form>
                        </div>
    
                        {footer}
                    </div>
                </section>
            );
        }
        else{
            return(
                <section className="cdContactRoute">
                    <div className="cdContactWrap">
                        <div className="cdContactCard cdSuccessCard">
                            <div className="cdSuccessIcon">{'\u2713'}</div>
                            <div className="cdSuccessTitle">
                                {this.languageIndexer("Mensaje enviado", "Message sent")}
                            </div>
                            <div className="cdSuccessText">
                                {this.languageIndexer(
                                    "Gracias por escribirnos. Hemos recibido tu mensaje y te responderemos lo antes posible.",
                                    "Thanks for reaching out. We received your message and will reply as soon as possible."
                                )}
                            </div>
    
                            <div className="cdSuccessActions">
                                <button
                                    type="button"
                                    className="cdSecondaryBtn"
                                    onClick={()=>{
                                        this.setState({
                                            contactSent:false,
                                            contactName:'',
                                            contactEmail:'',
                                            contactPhone:'',
                                            contactMessage:''
                                        });
                                    }}
                                >
                                    {this.languageIndexer("Enviar otro", "Send another")}
                                </button>
    
                                <button
                                    type="button"
                                    className="cdPrimaryBtn"
                                    onClick={()=>{ this.setState({contentIndex:'main'}) }}
                                >
                                    {this.languageIndexer("Volver a Inicio", "Back to Home")}
                                </button>
                            </div>
                        </div>
    
                        {footer}
                    </div>
                </section>
            );
        }
    }
    

    renderMainLanding(helmetOverride = null){
        const landingCopy = this.getLandingCopy();
        const isInvestorsLanding = landingCopy.variantKey === 'inversionistas';
        const isCenteredLanding = true;
        const landingVariantClass = `cdMainRoute--${landingCopy.variantKey}`;
        const roleImages = [buyerImage, sellerImage, appraise];
        const roleImageAlts = ['buyer role', 'seller role', 'appraiser role'];
        const evidenceIcons = [complete, update, chartblue];

        return(
            <div className={`mainContent cdMainRoute ${landingVariantClass}`} id='mainContainer'>
                {helmetOverride || this.renderLandingHelmet(landingCopy)}
                <section className='cdLpHero' data-landing-section='hero'>
                    <div className='cdLpHeroInner'>
                        <div className={`cdLpHeroCopy${isCenteredLanding ? ' cdLpHeroCopyAudience' : ''}`}>
                            <div className={`cdLpKicker${isCenteredLanding ? ' cdLpKickerCentered' : ''}${isInvestorsLanding ? ' cdLpKickerInvestors' : ''}`}>
                                {landingCopy.heroKicker}
                            </div>
                            <h1 className={`cdLpHeroTitle${isCenteredLanding ? ' cdLpHeroTitleCentered' : ''}${isInvestorsLanding ? ' cdLpHeroTitleInvestors' : ''}`}>
                                {landingCopy.heroTitle}
                            </h1>
                            <p className={`cdLpHeroSubtitle${isCenteredLanding ? ' cdLpHeroSubtitleCentered' : ''}${isInvestorsLanding ? ' cdLpHeroSubtitleInvestors' : ''}`}>
                                {landingCopy.heroSubtitle}
                            </p>
                            <div className='cdLpHeroProofGrid'>
                                <div className='cdLpHeroProofChip cdLpMotionItem' style={this.getMotionStyle(1)}>
                                    <span className='cdLpHeroProofLabel'>{this.languageIndexer("Actualizado", "Updated through")}</span>
                                    <span>{landingCopy.heroFreshnessLabel}</span>
                                </div>
                                <div className='cdLpHeroProofChip cdLpMotionItem' style={this.getMotionStyle(2)}>
                                    <span className='cdLpHeroProofLabel'>{this.languageIndexer("Cobertura", "Coverage")}</span>
                                    <span>{landingCopy.proofCoverage}</span>
                                </div>
                                <div className='cdLpHeroProofChip cdLpMotionItem' style={this.getMotionStyle(3)}>
                                    <span className='cdLpHeroProofLabel'>{this.languageIndexer("Flujo", "Workflow")}</span>
                                    <span>{landingCopy.proofWorkflow}</span>
                                </div>
                                <div className='cdLpHeroProofChip cdLpMotionItem' style={this.getMotionStyle(4)}>
                                    <span className='cdLpHeroProofLabel'>{this.languageIndexer("Usado por", "Used by")}</span>
                                    <span>{landingCopy.proofUsedBy}</span>
                                </div>
                            </div>
                            <div className='cdLpHeroActions'>
                                <button
                                    type='button'
                                    className='cdLpPrimaryBtn'
                                    onClick={() => this.routeToPricing('hero_pricing_primary')}
                                >
                                    {landingCopy.heroPrimaryCta}
                                </button>
                                <button
                                    type='button'
                                    className='cdLpSecondaryBtn'
                                    onClick={() => this.scrollToLandingSection('cdDemoSection', 'hero_demo_secondary')}
                                >
                                    {landingCopy.heroSecondaryCta}
                                </button>
                            </div>
                            <div className='cdLpHeroFinePrint'>
                                {landingCopy.heroFinePrint}
                            </div>
                            <div className='cdLpHeroOverlay cdLpHeroOverlayInline'>
                                <div className='cdLpHeroOverlayEyebrow'>
                                    {landingCopy.overlayEyebrow}
                                </div>
                                <div className='cdLpHeroOverlayTitle'>
                                    {landingCopy.overlayTitle}
                                </div>
                                <div className='cdLpHeroOverlayCopy'>
                                    {landingCopy.overlayCopy}
                                </div>
                                <div className='cdLpHeroOverlayChips'>
                                    {landingCopy.overlayChips.map((chip, index) => (
                                        <span key={chip} style={this.getMotionStyle(index + 1)}>{chip}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className='cdLpHeroVisual'>
                            <picture>
                                <source
                                    media='(max-width: 780px)'
                                    srcSet={`${spreadsmallMobile480} 480w, ${spreadsmallMobile960} 960w`}
                                    sizes='100vw'
                                />
                                <img
                                    src={spreadmid}
                                    alt={this.languageIndexer("Vista del dashboard de CASADATA", "CASADATA dashboard preview")}
                                    loading='eager'
                                    decoding='async'
                                    fetchpriority='high'
                                    srcSet={`${spreadsmall} 1532w, ${spreadmid} 2486w`}
                                    sizes='(max-width: 1263px) 100vw, 58vw'
                                    width={2486}
                                    height={1840}
                                />
                            </picture>
                            <div className='cdLpHeroTag cdLpHeroTagTop'>
                                {this.getHeroFreshnessTagText()}
                            </div>
                            <div className='cdLpHeroTag cdLpHeroTagBottom'>
                                {this.languageIndexer("Cobertura completa de Puerto Rico", "Full Puerto Rico coverage")}
                            </div>
                        </div>
                    </div>
                </section>

                <section className='cdLpTrustStrip cdLpRevealSection' data-landing-section='trust'>
                    <div className='cdLpTrustGrid'>
                        {landingCopy.trustCards.map((card, index) => (
                            <article className='cdLpTrustCard cdLpMotionItem' key={card.title} style={this.getMotionStyle(index + 1)}>
                                <div className='cdLpTrustTitle'>{card.title}</div>
                                <div className='cdLpTrustValue'>{card.value}</div>
                                <div className='cdLpTrustDescription'>{card.description}</div>
                            </article>
                        ))}
                    </div>
                </section>

                <section className='cdLpHowSection cdLpRevealSection' data-landing-section='how'>
                    <div className='cdLpSectionTop cdLpMotionItem' style={this.getMotionStyle(0)}>
                        <h2>{landingCopy.howTitle}</h2>
                        <p>{landingCopy.howSubtitle}</p>
                    </div>
                    <div className='cdLpHowGrid'>
                        {landingCopy.howSteps.map((step, index) => (
                            <article className='cdLpHowCard cdLpMotionItem' key={step.title} style={this.getMotionStyle(index + 1)}>
                                <div className='cdLpHowStep'>{index + 1}</div>
                                <h3>{step.title}</h3>
                                <p>{step.description}</p>
                            </article>
                        ))}
                    </div>
                </section>

                <section className='cdLpRoleSection cdLpRevealSection' data-landing-section='roles'>
                    <div className='cdLpSectionTop cdLpMotionItem' style={this.getMotionStyle(0)}>
                        <h2>{landingCopy.roleTitle}</h2>
                        <p>{landingCopy.roleSubtitle}</p>
                    </div>
                    <div className='cdLpRoleGrid'>
                        {landingCopy.roleCards.map((card, index) => (
                            <article className='cdLpRoleCard cdLpMotionItem' key={card.title} style={this.getMotionStyle(index + 1)}>
                                <img src={roleImages[index]} alt={roleImageAlts[index]} loading='lazy' decoding='async' width={230} height={160} />
                                <h3>{card.title}</h3>
                                <p>{card.description}</p>
                            </article>
                        ))}
                    </div>
                </section>

                <section className='cdLpDemoSection cdLpRevealSection' id='cdDemoSection' data-landing-section='demo'>
                    <div className='cdLpDemoCopy cdLpMotionItem' style={this.getMotionStyle(0)}>
                        <h2>{landingCopy.demoTitle}</h2>
                        <p>{landingCopy.demoSubtitle}</p>
                        <div className='cdLpDemoActions'>
                            <button type='button' className='cdLpPrimaryBtn' onClick={() => this.routeToPricing('demo_pricing')}>
                                {landingCopy.demoPrimaryCta}
                            </button>
                            <button type='button' className='cdLpSecondaryBtn' onClick={() => this.routeToContact('demo_contact')}>
                                {landingCopy.demoSecondaryCta}
                            </button>
                        </div>
                    </div>
                    <div className='cdLpDemoMedia cdLpMotionItem' style={this.getMotionStyle(1)}>
                        {this.state.showDemoVideo ? (
                            <div className='cdLpVideoFrame'>
                                <iframe
                                    width='560'
                                    height='315'
                                    src='https://www.youtube.com/embed/gQ0DU7Kvjak?si=JIJa56XU6oi5ztDo'
                                    title='CASADATA product demo'
                                    loading='lazy'
                                    frameBorder='0'
                                    allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                                    referrerPolicy='strict-origin-when-cross-origin'
                                    allowFullScreen
                                />
                            </div>
                        ) : (
                            <button type='button' className='cdLpVideoPoster' onClick={() => this.playDemoVideo('poster_click')}>
                                <img src={selectedAreas} alt={this.languageIndexer("Vista previa del video demo", "Demo video preview")} loading='lazy' decoding='async' width={844} height={992} />
                                <span className='cdLpPlayButton'>{landingCopy.playDemoLabel}</span>
                            </button>
                        )}
                    </div>
                </section>

                <section className='cdLpEvidenceSection cdLpRevealSection' data-landing-section='evidence'>
                    <div className='cdLpSectionTop cdLpMotionItem' style={this.getMotionStyle(0)}>
                        <h2>{landingCopy.evidenceTitle}</h2>
                        <p>{landingCopy.evidenceSubtitle}</p>
                    </div>
                    <div className='cdLpEvidenceGrid'>
                        {landingCopy.evidenceCards.map((card, index) => (
                            <article className='cdLpEvidenceCard cdLpMotionItem' key={card.title} style={this.getMotionStyle(index + 1)}>
                                <img
                                    src={evidenceIcons[index]}
                                    alt={index === 0 ? 'methodology icon' : index === 1 ? 'update icon' : 'report icon'}
                                    loading='lazy'
                                    decoding='async'
                                    width={42}
                                    height={42}
                                />
                                <h3>{card.title}</h3>
                                <p>{card.description}</p>
                            </article>
                        ))}
                    </div>
                </section>

                <section className='cdLpFaqSection cdLpRevealSection' data-landing-section='faq'>
                    <div className='cdLpSectionTop cdLpMotionItem' style={this.getMotionStyle(0)}>
                        <h2>{landingCopy.faqTitle}</h2>
                    </div>
                    <div className='cdLpFaqList'>
                        {landingCopy.faqItems.map((item, index) => (
                            <details key={item.question} className='cdLpMotionItem' style={this.getMotionStyle(index + 1)}>
                                <summary>{item.question}</summary>
                                <p>{item.answer}</p>
                            </details>
                        ))}
                    </div>
                </section>

                <section className='cdLpFinalBand cdLpRevealSection' data-landing-section='final'>
                    <h2 className='cdLpMotionItem' style={this.getMotionStyle(0)}>{landingCopy.finalTitle}</h2>
                    <div className='cdLpFinalBandActions cdLpMotionItem' style={this.getMotionStyle(1)}>
                        <button type='button' className='cdLpPrimaryBtn' onClick={() => this.routeToPricing('final_band_pricing')}>
                            {landingCopy.finalPrimaryCta}
                        </button>
                        <button type='button' className='cdLpSecondaryBtn' onClick={() => this.routeToContact('final_band_contact')}>
                            {landingCopy.finalSecondaryCta}
                        </button>
                    </div>
                </section>

                <footer className='cdLpFooter cdLpRevealSection' data-landing-section='footer'>
                    <div className='cdLpFooterLinks cdLpMotionItem' style={this.getMotionStyle(0)}>
                        <a href='/es/estadisticas-puerto-rico'>{this.languageIndexer("Estadísticas Puerto Rico", "Puerto Rico Statistics")}</a>
                        <button type='button' onClick={()=>this.props.termsWindowShow()}>{this.languageIndexer("Terminos de Uso", "Terms of Use")}</button>
                        <button type='button' onClick={()=>this.props.policyWindowShow()}>{this.languageIndexer("Politica de Privacidad", "Privacy Policy")}</button>
                    </div>
                    <div className='cdLpFooterMeta cdLpMotionItem' style={this.getMotionStyle(1)}>
                        <span>information@casadata.io</span>
                        <span>CASADATA LLC (c) 2026</span>
                    </div>
                </footer>
            </div>
        );
    }

    contentIndexer(){
        if(this.state.contentIndex==='main'){
            const seoTopicPage = this.getSeoTopicPage();
            if (seoTopicPage && (this.state.seoTopicHold || seoTopicPage.statsEmbed)) {
                return this.renderSeoTopicPage(seoTopicPage);
            }
            return this.renderMainLanding(seoTopicPage ? this.renderSeoTopicHelmet(seoTopicPage) : null);
        }
        else if (this.state.contentIndex === 'prices') {

            const seat = this.state.seatInfo || null;
            const seatReady = !!(seat && typeof seat.sold_out === 'boolean');
            const soldOut = seatReady ? !!seat.sold_out : false;
        
            const seatCap = seatReady ? Number(seat.seat_cap) : 50;
            const seatsUsed = seatReady ? Number(seat.seats_used) : null;
            const seatsRemaining = seatReady ? Number(seat.seats_remaining) : null;
        
            const seatPct =
                (seatReady && seatCap > 0 && typeof seatsUsed === 'number')
                    ? Math.min(100, Math.round((seatsUsed / seatCap) * 100))
                    : 0;
        
            // Use backend prices if available (so you only update in ONE place)
            const backendPrices = seatReady ? (seat.current_prices || {}) : {};
            const monthly = Number(backendPrices.monthly ?? paymentConfig.plusMaxMonthly);
            const yearly  = Number(backendPrices.annual  ?? paymentConfig.plusMaxYearly);
        
            const isMonthly = this.state.plusMaxBilling !== 'annual';
            const price = isMonthly ? monthly : yearly;
            const passPrice = Number(paymentConfig.pass72Price || 12.99);
        
            const savePct = (Number.isFinite(monthly) && monthly > 0 && Number.isFinite(yearly))
                ? Math.max(0, Math.round(100 - (yearly / (monthly * 12)) * 100))
                : 0;
        
            const annualAsLowAs = (Number.isFinite(yearly) && yearly > 0)
                ? (yearly / 12).toFixed(2)
                : '';
        
            const lockCTA = this.state.seatLoading || soldOut;
        
            return (
                <section className='finalContentContainer cdPricesRoute'>
                    <div className='finalContent cdPricesContent'>
        
                        <div className='cdPricesHeader'>
                            <div className='cdPricesTitle'>
                                {this.languageIndexer("Planes", "Pricing")}
                            </div>
                            <div className='cdPricesSubtitle'>
                                {this.languageIndexer(
                                    "Elige PlusMAX para acceso completo o usa el Pase 72h cuando necesitas evidencia hoy sin recurrencia.",
                                    "Choose PlusMAX for full access or use the 72-hour pass when you need evidence today without recurring billing."
                                )}
                            </div>
                            {(() => {
                                // Backend eligibility denials all mean "already used".
                                const reasonAliases = {
                                    fpjs_visitor_id: 'trial_used',
                                    customer_fingerprint: 'trial_used',
                                    device: 'trial_used',
                                    ip_limit: 'trial_used'
                                };
                                const landingNotices = {
                                    pass_expired: this.languageIndexer(
                                        "Tu Pase de 72 horas expiró. Puedes suscribirte a PlusMAX o comprar otro pase cuando lo necesites.",
                                        "Your 72-hour pass expired. You can subscribe to PlusMAX or buy another pass when you need it."
                                    ),
                                    trial_expired: this.languageIndexer(
                                        "Tu prueba gratis terminó. Continúa donde quedaste con el Pase de 72 horas o suscríbete a PlusMAX.",
                                        "Your free trial ended. Pick up where you left off with the 72-hour Pass or subscribe to PlusMAX."
                                    ),
                                    trial_used: this.languageIndexer(
                                        "Ya usaste tu prueba gratis en este dispositivo. El Pase de 72 horas te da acceso completo hoy, sin suscripción.",
                                        "You already used your free trial on this device. The 72-hour Pass gives you full access today, no subscription."
                                    ),
                                    trial_upgrade: this.languageIndexer(
                                        "Tu prueba sigue activa. Activa PlusMAX o el Pase de 72 horas para mantener tu acceso sin interrupciones.",
                                        "Your trial is still active. Activate PlusMAX or the 72-hour Pass to keep your access uninterrupted."
                                    ),
                                    existing_customer: this.languageIndexer(
                                        "La prueba gratis es para nuevos visitantes. Inicia sesión para entrar a tu cuenta o activa un plan.",
                                        "The free trial is for new visitors. Log in to your account or activate a plan."
                                    )
                                };
                                const reasonKey = reasonAliases[this.props.landingReason] || this.props.landingReason;
                                const notice = landingNotices[reasonKey];
                                return notice ? (
                                    <div className='cdPassExpiredNotice'>
                                        {notice}
                                        {this.props.landingReason === 'trial_upgrade' && typeof this.props.onResumeTrial === 'function' ? (
                                            <div
                                                onClick={() => this.props.onResumeTrial()}
                                                style={{marginTop:6,fontWeight:800,textDecoration:'underline',cursor:'pointer'}}
                                            >
                                                {this.languageIndexer('← Volver a tu prueba', '← Back to your trial')}
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null;
                            })()}
                        </div>
        
                        <div className='cdPriceCard'>
        
                            <div className='cdCardTopRow'>
                                <div className='cdPlanNameRow'>
                                    <div className='cdPlanName'>PlusMAX</div>
                                    <div className='cdPlanPill'>
                                        {this.languageIndexer("ACCESO COMPLETO", "FULL ACCESS")}
                                    </div>
                                </div>
                                {/* <div className='cdPlanValuePill'>
                                    {this.languageIndexer("MEJOR VALOR", "BEST VALUE")}
                                </div> */}
                            </div>
        
                            {/* Seat availability */}
                            <div className='cdSeatMeta'>
                                <div className={
                                    'cdSeatPill ' +
                                    (soldOut ? 'soldOut' : (seatReady && seatsRemaining <= 5 ? 'low' : ''))
                                }>
                                    {soldOut
                                        ? this.languageIndexer("SIN ESPACIOS", "SOLD OUT")
                                        : this.languageIndexer("ESPACIOS OCUPADOS", "OCCUPIED SEATS")
                                    }
                                    {" "}
                                    {this.state.seatLoading || !seatReady ? "..." : `${seatsUsed}/${seatCap}`}
                                </div>
        
                                <div className={'cdSeatText ' + (this.state.seatError ? 'error' : '')}>
                                    {this.state.seatLoading
                                        ? this.languageIndexer("Verificando disponibilidad...", "Checking availability...")
                                        : this.state.seatError
                                            ? this.languageIndexer("No se pudo verificar disponibilidad.", "Could not verify availability.")
                                            : soldOut
                                                ? this.languageIndexer("No hay espacios disponibles en este lote.", "No seats available in this batch.")
                                                : this.languageIndexer(`Quedan ${seatsRemaining} espacios.`, `${seatsRemaining} seats remaining.`)
                                    }
                                    {this.state.seatError ? (
                                        <button type="button" className="cdSeatRetry" onClick={this.fetchPlusMaxSeatStatus}>
                                            {this.languageIndexer("Reintentar", "Retry")}
                                        </button>
                                    ) : null}
                                </div>
                            </div>
        
                            <div className='cdSeatBarOuter'>
                                <div className='cdSeatBarInner' style={{ width: (seatReady ? `${seatPct}%` : '0%') }} />
                            </div>
        
                            {soldOut && seat && seat.next_prices ? (
                                <div className='cdSoldOutNote'>
                                    {this.languageIndexer(
                                        "Este lote esta completo. Abriremos nuevos espacios en cuanto validemos disponibilidad.",
                                        "This batch is sold out. Our team will open new seats soon."
                                    )}
                                </div>
                            ) : (
                                <div className='cdSeatHint'>
                                    {this.languageIndexer(
                                        `Disponibilidad visible en tiempo real (${seatCap} espacios por lote).`,
                                        `Live availability shown in real-time (${seatCap} seats per batch).`
                                    )}
                                </div>
                            )}
        
                            <div className='cdPriceRow'>
                                <div className='cdPriceBig'>
                                    <span className='cdCurrency'>$</span>
                                    <span className='cdNumber'>{this.formatMoney(price)}</span>
                                </div>
                                <div className='cdInterval'>
                                    {isMonthly ? this.languageIndexer("/mes", "/mo") : this.languageIndexer("/ano", "/yr")}
                                </div>
                            </div>
        
                            <div className='cdValueLine'>
                                {isMonthly
                                    ? this.languageIndexer(
                                        "Facturacion mensual flexible. Cancela cuando quieras.",
                                        "Renews monthly. Cancel anytime."
                                    )
                                    : this.languageIndexer(
                                        `Ahorra ${savePct}% al facturar anual | Equivale a $${annualAsLowAs}/mes`,
                                        `Save ${savePct}% | As low as $${annualAsLowAs}/mo`
                                    )
                                }
                            </div>

                            <div className='cdFounderPriceNote'>
                                {/* <div className='cdFounderNoteHeader'>
                                    <div className='cdFounderNoteBadge'>600</div>
                                    <div>
                                        <div className='cdFounderNoteEyebrow'>
                                            {this.languageIndexer("Acceso temprano", "Early access")}
                                        </div>
                                        <div className='cdFounderNoteTitle'>
                                            {this.languageIndexer("Precio fundador PlusMAX", "PlusMAX founder price")}
                                        </div>
                                    </div>
                                </div> */}
                                <div className='cdFounderNoteBody'>
                                    {/* <p>
                                        {this.languageIndexer(
                                            "CASADATA esta en una etapa de crecimiento y este precio especial esta reservado para los primeros 500 espacios. Es nuestra forma de agradecer a los usuarios que adoptan la plataforma temprano y ayudan a impulsar una forma mas clara de analizar el mercado inmobiliario de Puerto Rico.",
                                            "CASADATA is in a growth stage, and this special price is reserved for the first 500 seats. It is our way of thanking users who adopt the platform early and help advance a clearer way to analyze Puerto Rico's real estate market."
                                        )}
                                    </p> */}
                                    <p>
                                        {this.languageIndexer(
                                            "Los miembros activos conservan este precio mientras su suscripcion permanezca vigente. Al completarse este lote, abriremos la proxima etapa de acceso con una nueva estructura de precios.",
                                            "Active members keep this price while their subscription remains active. Once this batch is complete, we will open the next access stage with a new pricing structure."
                                        )}
                                    </p>
                                </div>
                            </div>
        
                            <div className='cdToggle'>
                                <button
                                    type="button"
                                    disabled={soldOut}
                                    className={'cdToggleBtn ' + (isMonthly ? 'active' : '')}
                                    onClick={() => this.selectPlusMaxBilling('monthly')}
                                >
                                    <div className='cdToggleMain'>
                                        {this.languageIndexer("Mensual", "Monthly")}
                                    </div>
                                    <div className='cdToggleSub'>
                                        ${this.formatMoney(monthly)} {this.languageIndexer("por mes", "per month")}
                                    </div>
                                </button>
        
                                <button
                                    type="button"
                                    disabled={soldOut}
                                    className={'cdToggleBtn ' + (!isMonthly ? 'active' : '')}
                                    onClick={() => this.selectPlusMaxBilling('annual')}
                                >
                                    <div className='cdToggleMain'>
                                        <span>{this.languageIndexer("Anual", "Yearly")}</span>
                                        <span className='cdSaveBadge'>
                                            {this.languageIndexer("Ahorra", "Save")} {savePct}%
                                        </span>
                                    </div>
                                    <div className='cdToggleSub'>
                                        ${this.formatMoney(yearly)} {this.languageIndexer("por año", "per year")}
                                    </div>
                                </button>
                            </div>
        
                            <div className='cdDivider' />
        
                            <ul className='cdFeatureList'>
                                <li>{this.languageIndexer("Comparables actualizados para residencial, multifamiliar, solar y comercial.", "Updated comparables for residential, multifamily, land, and commercial assets.")}</li>
                                <li>{this.languageIndexer("Filtros por zona, precio, fecha y tamano para encontrar evidencia en minutos.", "Filters by area, price, date, and size to find evidence in minutes.")}</li>
                                <li>{this.languageIndexer("Mapas interactivos para validar contexto de mercado antes de recomendar.", "Interactive maps to validate market context before you recommend.")}</li>
                                <li>{this.languageIndexer("Analisis de tendencias, liquidez y rangos de precio.", "Trend, liquidity, and pricing range analytics.")}</li>
                                <li>{this.languageIndexer("Estimado de valor y equidad para conversaciones de compra o venta.", "Value and equity estimates for buy or sell conversations.")}</li>
                                <li>{this.languageIndexer("Busqueda ilimitada y exportacion a Excel para presentaciones profesionales.", "Unlimited search and Excel export for professional presentations.")}</li>
                                <li>{this.languageIndexer("Datos de comprador y vendedor para negociar con mejor información.", "Buyer and seller data to negotiate with stronger information.")}</li>
                                <li>{this.languageIndexer("Mensual y anual incluyen comprador/vendedor, exportación CSV y documentos Karibe cuando estén disponibles.", "Monthly and yearly include buyer/seller names, CSV export, and Karibe documents when available.")}</li>
                                <li>{this.languageIndexer("Marcadores de propiedades reposeidas, refinanciadas e inundables.", "Markers for repossessed, refinanced, and flood-risk properties.")}</li>
                                <li>{this.languageIndexer("Soporte en espanol e ingles para tu equipo.", "Spanish and English support for your team.")}</li>
                            </ul>
        
                            <button
                                type="button"
                                className={'cdSelectBtn ' + (lockCTA ? 'disabled' : '')}
                                disabled={lockCTA}
                                onClick={() => {
                                    if (lockCTA) return;
                                    track('InitiateCheckout', {
                                        plan: 'PlusMAX',
                                        billing: (isMonthly ? 'monthly' : 'annual'),
                                        value: price,
                                        currency: 'USD'
                                    });
                                    trackBeginCheckout({
                                        plan: 'PlusMAX',
                                        billing: (isMonthly ? 'monthly' : 'annual'),
                                        value: price,
                                        source: 'pricing_continue_cta'
                                    });
                                    trackEvent('auth_drawer_opened', {
                                        plan_tier: 'PlusMAX',
                                        billing_cycle: (isMonthly ? 'monthly' : 'annual'),
                                        source: 'pricing_activate_access'
                                    });
                                    this.props.openDirectCheckout({
                                        billingCycle: (isMonthly ? 'monthly' : 'annual')
                                    });
                                    sendAnalytics(
                                        "CHECKOUT",
                                        `Opened direct checkout by PlusMAX (${isMonthly ? 'monthly' : 'annual'}).`,
                                        String(new Date())
                                    );
                                }}
                            >
                                {soldOut
                                    ? this.languageIndexer("SIN ESPACIOS", "SOLD OUT")
                                    : (this.state.seatLoading
                                        ? this.languageIndexer("CARGANDO...", "LOADING...")
                                        : this.languageIndexer("ACTIVAR ACCESO", "ACTIVATE ACCESS"))
                                }
                            </button>
                            {/* <div className='cdPostCtaHint'>
                                {this.languageIndexer(
                                    "Al continuar abriremos login seguro y pago directo para activar PlusMAX en minutos.",
                                    "By continuing, secure sign-in and direct payment will open so you can activate PlusMAX in minutes."
                                )}
                            </div> */}
                            {this.renderPricingTrialOffer()}
        
                            <div className='cdFinePrint'>
                                {this.languageIndexer("Pago recurrente. Sin permanencia forzada; cancela cuando quieras.", "Recurring billing. No forced commitment; cancel anytime.")}
                            </div>
                        </div>

                        {(() => {
                            const proIsMonthly = this.state.proBilling !== 'annual';
                            const proPrice = proIsMonthly ? paymentConfig.plusMaxProMonthly : paymentConfig.plusMaxProYearly;
                            const proBillingKey = proIsMonthly ? 'monthly' : 'annual';
                            return (
                                <div className='cdPriceCard cdProPriceCard' data-plan='plusmax_pro'>
                                    <div className='cdCardTopRow'>
                                        <div className='cdPlanNameRow'>
                                            <div className='cdPlanName'>PlusMAX Pro</div>
                                            <div className='cdPlanPill cdProPlanPill'>
                                                {this.languageIndexer("PROFESIONALES", "PROFESSIONALS")}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='cdPriceRow'>
                                        <div className='cdPriceBig'>
                                            <span className='cdCurrency'>$</span>
                                            <span className='cdNumber'>{this.formatMoney(proPrice)}</span>
                                        </div>
                                        <div className='cdInterval'>
                                            {proIsMonthly ? this.languageIndexer("/mes + IVU", "/mo + tax") : this.languageIndexer("/año + IVU", "/yr + tax")}
                                        </div>
                                    </div>

                                    <div className='cdValueLine'>
                                        {this.languageIndexer(
                                            "Todo lo de PlusMAX, más herramientas de informe y análisis para profesionales.",
                                            "Everything in PlusMAX, plus reporting and analysis tools built for professionals."
                                        )}
                                    </div>

                                    <div className='cdToggle'>
                                        <button
                                            type="button"
                                            className={'cdToggleBtn ' + (proIsMonthly ? 'active' : '')}
                                            onClick={() => this.selectProBilling('monthly')}
                                        >
                                            <div className='cdToggleMain'>{this.languageIndexer("Mensual", "Monthly")}</div>
                                            <div className='cdToggleSub'>
                                                ${this.formatMoney(paymentConfig.plusMaxProMonthly)} {this.languageIndexer("por mes", "per month")}
                                            </div>
                                        </button>
                                        <button
                                            type="button"
                                            className={'cdToggleBtn ' + (!proIsMonthly ? 'active' : '')}
                                            onClick={() => this.selectProBilling('annual')}
                                        >
                                            <div className='cdToggleMain'>{this.languageIndexer("Anual", "Yearly")}</div>
                                            <div className='cdToggleSub'>
                                                ${this.formatMoney(paymentConfig.plusMaxProYearly)} {this.languageIndexer("por año", "per year")}
                                            </div>
                                        </button>
                                    </div>

                                    <div className='cdDivider' />

                                    <div className='cdProEverything'>
                                        <div className='cdProEverythingTitle'>
                                            ✓ {this.languageIndexer("TODO LO DE PLUSMAX INCLUIDO", "EVERYTHING IN PLUSMAX INCLUDED")}
                                        </div>
                                        <div className='cdProEverythingBody'>
                                            {this.languageIndexer(
                                                "Precios y fechas de venta, comprador/vendedor, búsquedas ilimitadas, exportación CSV, reposeídas y refinanciadas, CRIM, inundabilidad y estadísticas completas.",
                                                "Sale prices and dates, buyer/seller names, unlimited searches, CSV export, repossessed and refinanced markers, property tax, flood risk, and full analytics."
                                            )}
                                        </div>
                                    </div>

                                    <div className='cdProOnlyLabel'>
                                        {this.languageIndexer("EXCLUSIVO DE PRO", "PRO EXCLUSIVE")}
                                    </div>
                                    <ul className='cdFeatureList'>
                                        <li>{this.languageIndexer("Informe PDF de comparables con tu nombre y marca.", "Comparables PDF report with your name and brand.")}</li>
                                        <li>{this.languageIndexer("Historial de informes.", "Report history.")}</li>
                                        <li>{this.languageIndexer("Áreas guardadas con resumen al iniciar sesión.", "Saved areas with a summary when you sign in.")}</li>
                                        <li>{this.languageIndexer("Chat de análisis con IA sobre tus datos.", "AI analysis chat about your data.")}</li>
                                    </ul>

                                    <button
                                        type="button"
                                        className='cdSelectBtn cdProSelectBtn'
                                        onClick={() => {
                                            track('InitiateCheckout', {
                                                plan: 'PlusMAXPro',
                                                billing: proBillingKey,
                                                value: proPrice,
                                                currency: 'USD'
                                            });
                                            trackBeginCheckout({
                                                plan: 'PlusMAXPro',
                                                billing: proBillingKey,
                                                value: proPrice,
                                                source: 'pricing_pro_cta'
                                            });
                                            trackEvent('auth_drawer_opened', {
                                                plan_tier: 'PlusMAXPro',
                                                billing_cycle: proBillingKey,
                                                source: 'pricing_pro_cta'
                                            });
                                            this.props.openDirectCheckout({
                                                billingCycle: proIsMonthly ? 'pro_monthly' : 'pro_annual'
                                            });
                                            sendAnalytics(
                                                "CHECKOUT",
                                                `Opened direct checkout by PlusMAX Pro (${proBillingKey}).`,
                                                String(new Date())
                                            );
                                        }}
                                    >
                                        {this.languageIndexer("ACTIVAR PLUSMAX PRO", "ACTIVATE PLUSMAX PRO")}
                                    </button>

                                    <div className='cdFinePrint'>
                                        {this.languageIndexer("Pago recurrente. Cancela cuando quieras.", "Recurring billing. Cancel anytime.")}
                                    </div>
                                </div>
                            );
                        })()}

                            <div className='cdPriceCard cdPassPriceCard' data-plan='pass72'>
                                <div className='cdCardTopRow'>
                                    <div className='cdPlanNameRow'>
                                        <div className='cdPlanName'>{this.languageIndexer('Pase 72h', '72h Pass')}</div>
                                        <div className='cdPlanPill'>
                                            {this.languageIndexer('SIEMPRE DISPONIBLE', 'ALWAYS AVAILABLE')}
                                        </div>
                                    </div>
                                </div>

                                {soldOut ? (
                                    <div className='cdPassBridgeNote'>
                                        {this.languageIndexer(
                                            'Mientras esperas un espacio PlusMAX, el Pase 72h te da acceso hoy sin consumir un asiento.',
                                            'While you wait for a PlusMAX seat, the 72h pass gives you access today without consuming a seat.'
                                        )}
                                    </div>
                                ) : null}

                                <div className='cdPriceRow cdPassPriceRow'>
                                    <div className='cdPriceBig'>
                                        <span className='cdCurrency'>$</span>
                                        <span className='cdNumber'>{this.formatMoney(passPrice)}</span>
                                    </div>
                                    <div className='cdInterval'>+ IVU</div>
                                </div>

                                <div className='cdValueLine'>
                                    {this.languageIndexer('Pago único. No se renueva automáticamente.', 'One-time payment. Does not auto-renew.')}
                                </div>

                                <div className='cdDivider' />

                                <ul className='cdFeatureList cdPassFeatureList'>
                                    <li>{this.languageIndexer('72 horas de búsqueda, precios de venta, fechas y tamaños.', '72 hours of search, sale prices, dates, and sizes.')}</li>
                                    <li>{this.languageIndexer('Estimado de valor, equidad, CRIM e indicador de inundabilidad.', 'Value, equity, property-tax, and flood-risk estimates.')}</li>
                                    <li>{this.languageIndexer('Marcadores de reposeídas, refinanciadas y capa de repos.', 'Repossessed, refinanced, and repo-layer markers.')}</li>
                                    <li>{this.languageIndexer('Panel completo de estadísticas y tendencias.', 'Full statistics and trend analytics panel.')}</li>
                                </ul>

                                <button
                                    type='button'
                                    className='cdSelectBtn cdPassSelectBtn'
                                    onClick={() => {
                                        track('InitiateCheckout', {
                                            plan: 'Pass72',
                                            billing: 'one_time',
                                            value: passPrice,
                                            currency: 'USD'
                                        });
                                        trackBeginCheckout({
                                            plan: 'Pass72',
                                            billing: 'one_time',
                                            value: passPrice,
                                            source: 'pricing_pass72_cta'
                                        });
                                        trackEvent('auth_drawer_opened', {
                                            plan_tier: 'Pass72',
                                            billing_cycle: 'one_time',
                                            value: passPrice,
                                            currency: 'USD',
                                            source: 'pricing_pass72_cta'
                                        });
                                        this.props.openDirectCheckout({ billingCycle: 'pass72' });
                                        sendAnalytics('CHECKOUT', 'Opened direct checkout by Pass72.', String(new Date()));
                                    }}
                                >
                                    {this.languageIndexer('COMPRAR PASE 72H', 'BUY 72H PASS')}
                                </button>


                            </div>
        
                        <div style={{ fontSize: 14, color: 'rgba(0,0,0,.6)', fontWeight: 700, marginTop: 18 }}>
                            <div className='bottomNav'>
                                <div onClick={() => this.props.termsWindowShow()}>Terminos de Uso</div>
                                <div onClick={() => this.props.policyWindowShow()}>Politica de Privacidad</div>
                            </div>
                            <div style={{ color: 'rgba(0,0,0,.8)' }}>
                                Copyright (c) CASADATA LLC 2026. All Rights Reserved.
                            </div>
                        </div>
        
                    </div>
                </section>
            );
        }
         
        else if(this.state.contentIndex==='contact'){
            return(
                this.contactSent()
            );
        }
        else if(this.state.contentIndex==='person'){
            return(
                <section className='accountSelection'>
                    <div className='accountSelectionContainer'>
                        <div
                            style={{
                                color:'rgba(0,0,0,.5)',
                                fontSize:25,
                                marginTop:40,
                                fontWeight:700
                            }}
                            >{this.languageIndexer("Bienvenidos a CASADATA", "Welcome to CASADATA")}</div>
                            <div className='noAcctText'>
                                {this.languageIndexer("Aun sin cuenta? Crea la tuya y empieza a usar comparables hoy.", "No account yet? Create yours and start using comparables today.")}
                            </div>
                            <button onClick={()=>{
                                trackEvent('auth_entry_click', { target: 'signup', source: 'frontpage_person' });
                                this.trackAuthIntent('signup', 'frontpage_person');
                                this.props.signupWindow();
                            }} className="ver-ofertas-button2">
                                {this.languageIndexer("Registrate", "Sign Up")}
                            </button>
                            <div className='noAcctText'>
                                {this.languageIndexer("O si ya tienes cuenta:", "If you already have an account:")}
                            </div>
                            <button onClick={()=>{
                                trackEvent('auth_entry_click', { target: 'login', source: 'frontpage_person' });
                                this.trackAuthIntent('login', 'frontpage_person');
                                this.props.loginWindow();
                            }} className="ver-ofertas-button2">
                                {this.languageIndexer("Login", "Login")}
                            </button>
                    </div>
                </section>
            );
        }
    }
    
    render(){
        
        return(
            <div 
            onMouseDown={()=>this.props.holdTheMapStill()}
            onTouchStart={()=>this.props.holdTheMapStill()}
            onMouseUp={()=>this.props.releaseTheMap()}
            onTouchEnd={()=>this.props.releaseTheMap()}
            className="frontPage"
            >
                <section className='frontPageContent'>
                    {this.navBarIndexer()}
                    {this.contentIndexer()}
                    {this.state.enableChatbot ? (
                        <Suspense fallback={null}>
                            <Chatbot serverIP={this.state.serverIp}/>
                        </Suspense>
                    ) : null}
                </section>
            </div>
        );
    }   
}

export default Frontpage;



